//---+m*+m+-+-%-+--+-..%*#%mmm%- -.-.-------       ..	  ...-.. -
// ---+-----++-------++*%#+##+%++---/      /\+-+ +.-  .	+-.	.-.m.#..
//-|                 |    ####-++/+       /xxxx\ ..- -+. -.%++.+--..
//.|  DfPE main JS!  | .-m+####*/        /xxxxxx\+-#..+m+.###+###+ .
//.|                 |.  -.##+*%|       -xxxxxxxx###*+m-#+#.##-+*--.
//.+-----------------+- ######m-\               /%m+-.#-+m%	%m.m+.--.
//.	. #####+%*#m-*#%###########m%\             /+m-+##m+-.---.#*m.
// .. *m-##m###++*-#m########*mmm.--\       /--+m%.+-----.	. %%  .
// 	 .--+-+.*-.+ +--#..**#**m.+	. -+.+-------%---... --*.	  -.  .
// 		-. m--+. .-. -.+m%-.-	   . . ..+.m.. -  .	 - .  .	  --- .
// 		 ..-.		- .-   .		        	- ..  .	 .	.  m

/**
 * @file main.js
 * @author Geoffrey Pursell
 * @desc main entry point for DfPE
 */

window.debugEnabled = true;

// declare dependencies and establish the module closure

define('main',[
  "require",
  // app modules
  "controllers",
  "cardboard/baseViews",
  "views",
  "commonDataSources",
  "commonDataSourceManager",
  "router",
  "cardboard/jQMSetup",
  "cardboard/util",
  "plugins/all",

  // libraries
  "jquery",
  "jsImgSlider",
  "slick",
  "underscore",
  "backbone",
  "bowser",
  "html2canvas",
  "html2canvasSVG",
  "jszip",
  "xlsx",
  "blob",
  "filesaver",
  "tableexport",
  "tablesorter",
  "accordion",
  "waitUntilExists",
  "modernizr" /* , "video" */,
], function (
  require,
  // app modules
  Controllers,
  BaseViews,
  Views,
  CommonDataSources,
  CommonDataSourceManager,
  AppRouter,
  jQueryMobileSetup,
  Util,
  Plugins,

  // libraries
  $,
  jsImgSlider,
  slick,
  _,
  Backbone,
  Bowser,
  html2canvas,
  html2canvasSVG,
  JSZip,
  xlsx,
  Blob,
  filesaver,
  tableExport,
  TableSorter,
  accordion,
  waitUntilExists
) {
  /**
   * @module main
   * @desc main entry point for DfPE
   */

  var exports = {};

  console.log("MODULE: main");
 // var vizzes = {};

  //var ch3aURL = "https://analytics.education.state.mn.us/t/MDEPublic/views/PROD-ECDataStories_Chapter3_03_26_2020_v2/Chapter3-ProgramParticipation?:embed=y&:toolbar=no";
  //var ch3bURL = "https://analytics.education.state.mn.us/t/MDEPublic/views/PROD-ECDataStories_Chapter3_03_26_2020_v2/Chapter3-FoodandEconomicAssistance?:embed=y&:toolbar=no";
  //   var ch3bURL = "https://analytics.stage.education.state.mn.us/t/MDEPublic/views/38_ECLDS_Cleaned_AS/DashboardforPublish?:showAppBanner=false&:display_count=n&:showVizHome=n";
  //Stage  var ch3aURL = "https://analytics.stage.education.state.mn.us/t/MDEPublic/views/42_ECLDS_Cleaned_AS/DashboardforPublish?:iid=1:showAppBanner=false&:display_count=n&:showVizHome=n";
  //var ch3aURL = "https://analytics.education.state.mn.us/t/MDEPublic/views/ECLDSDataStoriesProd/Dashboard?:iid=2:showAppBanner=false&:display_count=n&:showVizHome=n";
  // var ch3aURL = "https://analytics.stage.education.state.mn.us/t/MDEPublic/views/38_ECLDS_Cleaned_AS/DashboardforPublish?:showAppBanner=false&:display_count=n&:showVizHome=n";
  //    var ch4aURL = "https://analytics.education.state.mn.us/t/MDEPublic/views/PROD-ECDataStories_Chapter4_03_26_2020_v2/Chapter4?:embed=y&:toolbar=no";
  //  var ch5aURL = "https://analytics.education.state.mn.us/t/MDEPublic/views/PROD-ECDataStories_Chapter5_03_26_2020/Chapter5-MFIPFoodAssistance?:embed=y&:toolbar=no";
 // var ch5aURL =   "https://analytics.stage.education.state.mn.us/t/MDEPublic/views/39_ECLDS_Cleaned_AS_Chapter_5/Chapter5Dashboard?:showAppBanner=false&:display_count=n&:showVizHome=n&:origin=viz_share_link";

 // var ch3aVizDiv = document.getElementById("ch3a");
  //      var ch3bVizDiv = document.getElementById("ch3b");
  //    var ch4aVizDiv = document.getElementById("ch4a");
 // var ch5aVizDiv = document.getElementById("ch5a");

  //
  // STUFF TO DO IMMEDIATELY ON MODULE LOAD
  //

  // start loading the common data sources (including the big org list) ASAP,
  // event before the DOM ready or the main module has a chance to load or
  // execute.
  var commonDataSourceManager = new CommonDataSourceManager(),
    commonSourcesLoaded = commonDataSourceManager.fetchCommonDataSources();

  function displayBrowserWarning() {
    var warningSelector;

    if (Bowser.android && !Bowser.chrome) {
      warningSelector = "#androidWarning";
    } else if (Bowser.msie && Bowser.version < 10) {
      warningSelector = "#ie9Warning";
    }
    if (warningSelector) {
      $(warningSelector).show();
    }
  }

  //------------------------------------------------------------
  // Initialization											 |
  //------------------------------------------------------------

  // initial page setup is here.
  $(function () {
    displayBrowserWarning();

    // I know all this is super-wrapped in callbacks, but we
    // need to make sure that jQuery mobile is loaded, AND the
    // DOM is ready before we proceed

    require(["jqMobile"], function () {
      var attemptingCommonSourceLoad = true,
        attempts = 0,
        maxAttempts = 3;

      // set a class if this is iOS6
      if (parseFloat(Bowser.ios && Bowser.version) < 7) {
        $("html").addClass("iOS6");
      }

  /*     function initViz(url, chartId, vizDiv, vizName) {
        //url = "https://analytics.dev.education.state.mn.us/t/MDEPublic/views/DEV-ECDataStories_Chapter4_12_12_18/Chapter4?:embed=y&:toolbar=no",

        options = {
          hideToolbar: true,
          onFirstInteractive: function () {
            getVizData(chartId, vizName);
            workbook = vizzes[vizName].getWorkbook();
            dash = vizzes[vizName].getWorkbook().getActiveSheet();
            workbook.activateSheetAsync(dash).then(function (dashboard) {
              //this is the secret sauce that stores all of the sheet names on the dashboard in an array named sheetNames
              var worksheets = dashboard.getWorksheets();
              //here is the aforementioned array
              var sheetNames = [];
              //here we are looping through all the sheets on the dash, & pushing the sheet name to the sheetNames array
              for (var i = 0, len = worksheets.length; i < len; i++) {
                var sheet = worksheets[i];
                sheetNames.push(sheet.getName());
              }

              //here is where we are creating our dropdown menu... kind of like a Tableau parameter
              //we will inject this value into the getVizData() function a little bit later
              var selection = document.getElementById("SheetList");
              var fragment = document.createDocumentFragment();
              sheetNames.forEach(function (sheetName, index) {
                var opt = document.createElement("option");
                opt.innerHTML = sheetName;
                opt.value = sheetName;
                fragment.appendChild(opt);
              });

              selection.appendChild(fragment);
            });
          },
        };

        vizzes[vizName] = new tableau.Viz(vizDiv, url, options);
      }

      //if you've made it to this point, know that the magic came from here: https://www.interworks.com/blog/rrouse/2016/06/07/pull-viz-data-new-javascript-api-features-tableau-10
      function getVizData(chartId, viz) {
        console.log(chartId);
        options = {
          maxRows: 0, // Max rows to return. Use 0 to return all rows
          ignoreAliases: false,
          ignoreSelection: true,
          includeAllColumns: false,
        };

        sheet = vizzes[viz].getWorkbook().getActiveSheet();
        console.log(sheet);

        //if active tab is a worksheet, get data from that sheet
        if (sheet.getSheetType() === "worksheet") {
          sheet.getUnderlyingDataAsync(options).then(function (t) {
            buildMenu(t);
          });
        } else {
          worksheetArray = vizzes[viz]
            .getWorkbook()
            .getActiveSheet()
            .getWorksheets();
          for (var i = 0; i < worksheetArray.length; i++) {
            worksheet = worksheetArray[i];
            sheetName = worksheet.getName();
            console.log(sheetName);
            if (chartId == "ch3a") {
              if (sheetName == "Participation Summary") {
                worksheetArray[i]
                  .getSummaryDataAsync(options)
                  .then(function (t) {
                    buildMenu(t, "Participation Summary", "ch3a");
                  });
              } else if (sheetName == "Racial Mix") {
                worksheetArray[i]
                  .getSummaryDataAsync(options)
                  .then(function (t) {
                    buildMenu(t, "Racial Mix", "ch3a");
                  });
              } else if (sheetName == "CCAP") {
                worksheetArray[i]
                  .getSummaryDataAsync(options)
                  .then(function (t) {
                    buildMenu(t, "CCAP", "ch3a");
                  });
              } else if (sheetName == "ECSE") {
                worksheetArray[i]
                  .getSummaryDataAsync(options)
                  .then(function (t) {
                    buildMenu(t, "ECSE", "ch3a");
                  });
              } else if (sheetName == "MN District Pre-K") {
                worksheetArray[i]
                  .getSummaryDataAsync(options)
                  .then(function (t) {
                    buildMenu(t, "MN District Pre-K", "ch3a");
                  });
              } else if (sheetName == "ECFE") {
                worksheetArray[i]
                  .getSummaryDataAsync(options)
                  .then(function (t) {
                    buildMenu(t, "ECFE", "ch3a");
                  });
              }
            } else if (chartId == "ch3b") {
              console.log(sheetName);
              if (sheetName == "Food and Econ Assistance Pie") {
                worksheetArray[i]
                  .getSummaryDataAsync(options)
                  .then(function (t) {
                    buildMenu(t, "Food and Econ Assistance Pie", "ch3b");
                  });
              } else if (sheetName == "Food and Economic Assistance Summary") {
                worksheetArray[i]
                  .getSummaryDataAsync(options)
                  .then(function (t) {
                    buildMenu(
                      t,
                      "Food and Economic Assistance Summary",
                      "ch3b"
                    );
                  });
              } else if (sheetName == "CCAP-Food Assistance") {
                worksheetArray[i]
                  .getSummaryDataAsync(options)
                  .then(function (t) {
                    buildMenu(t, "CCAP-Food Assistance", "ch3b");
                  });
              } else if (sheetName == "ECFE-Food Assistance") {
                worksheetArray[i]
                  .getSummaryDataAsync(options)
                  .then(function (t) {
                    buildMenu(t, "ECFE-Food Assistance", "ch3b");
                  });
              } else if (sheetName == "Pre-K-Food Assistance") {
                worksheetArray[i]
                  .getSummaryDataAsync(options)
                  .then(function (t) {
                    buildMenu(t, "Pre-K-Food Assistance", "ch3b");
                  });
              } else if (sheetName == "No ECE Data-Food Assistance") {
                worksheetArray[i]
                  .getSummaryDataAsync(options)
                  .then(function (t) {
                    buildMenu(t, "No ECE Data-Food Assistance", "ch3b");
                  });
              } else if (sheetName == "ECSE-Food Assistance") {
                worksheetArray[i]
                  .getSummaryDataAsync(options)
                  .then(function (t) {
                    buildMenu(t, "ECSE-Food Assistance", "ch3b");
                  });
              }
              // else if (sheetName == "Food and Econ Assistance") { worksheetArray[i].getSummaryDataAsync(options).then(function (t) { buildMenu(t, "Food and Econ Assistance", "ch3b"); }); }  
            } else if (chartId == "ch4a") {
              if (sheetName == "Poverty - Racial Mix") {
                worksheetArray[i]
                  .getSummaryDataAsync(options)
                  .then(function (t) {
                    buildMenu(t, "Poverty - Racial Mix", "ch4a");
                  });
              } else if (sheetName == "Poverty - Recap") {
                worksheetArray[i]
                  .getSummaryDataAsync(options)
                  .then(function (t) {
                    buildMenu(t, "Poverty - Recap", "ch4a");
                  });
              } else if (sheetName == "Summary - Pie") {
                worksheetArray[i]
                  .getSummaryDataAsync(options)
                  .then(function (t) {
                    buildMenu(t, "Summary - Pie", "ch4a");
                  });
              } else if (sheetName == "Summary - Data") {
                worksheetArray[i]
                  .getSummaryDataAsync(options)
                  .then(function (t) {
                    buildMenu(t, "Summary - Data", "ch4a");
                  });
              }
            } else if (chartId == "ch5a") {
              if (sheetName == "Poverty - MFIP/Food Assist") {
                worksheetArray[i]
                  .getSummaryDataAsync(options)
                  .then(function (t) {
                    buildMenu(t, "Poverty - MFIP/Food Assist", "ch5a");
                  });
              } else if (sheetName == "MFIP/Food Assist Header") {
                worksheetArray[i]
                  .getSummaryDataAsync(options)
                  .then(function (t) {
                    buildMenu(t, "MFIP/Food Assist Header", "ch5a");
                  });
              }
            }
          }
        }
      } */
      $(".your-class").slick({
        arrows: true,
        dots: true,
        infinite: true,
        speed: 500,
        fade: true,
        focusOnSelect: true,
        cssEase: "linear",
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        accessibility: true,
        autoplaySpeed: 25000,
        pauseOnDotsHover: true,
      });

      $(".slick-next").trigger("click");
      setTimeout(function () {
        $(".slick-prev").trigger("click");
    }, 1000);
    
      $("#toggleRace").click(
        function (event) {
          event.preventDefault();
          $.getJSON("/ibi_apps/WFServlet?IBIAPP_app=ECLDSwebsvc&IBIF_ex=ecldsws_getdata_filter_race_toggle.fex", function (data) {
            $.each( data, function( key, val ) {
              if(key == "data")
                  $("#toggleRace").html(val.race_message); 
            });
          });
        }
     );

      var sort_by = function (field, reverse, primer) {
        var key = function (x) {
          return primer ? primer(x[field]) : x[field];
        };

        return function (a, b) {
          var A = key(a),
            B = key(b);
          return (A < B ? -1 : A > B ? 1 : 0) * [-1, 1][+!!reverse];
        };
      };

      function numberWithCommas(x) {
        return x.toString().replace(/\B(?=(?:\d{3})+(?!\d))/g, ",");
      }
      //restructure the data and build something with it
      function buildMenu(table, sh, chId) {
        //the data returned from the tableau API
        var columns = table.getColumns();
        var data = table.getData();

        //convert to field:values convention
        function reduceToObjects(cols, data) {
          var fieldNameMap = $.map(cols, function (col) {
            return col.$impl.$fieldName;
          });
          var dataToReturn = $.map(data, function (d) {
            return d.reduce(function (memo, value, idx) {
              memo[fieldNameMap[idx]] = value.value;
              return memo;
            }, {});
          });
          return dataToReturn;
        }

        var niceData = reduceToObjects(columns, data);

        // console.log(sh);
        //console.log(niceData);
        if (chId == "ch3a") {
          if (sh == "Participation Summary") {
            if (niceData.length > 0) {
              tableStr =
                '<table class="dsTable" id="ch4aSummTable"><caption>ECE Participation Summary</caption><tbody><tr><th>All Kindergartners</th>';
              if (niceData[2]["Measure Values"] > 9) {
                tableStr +=
                  "<td>" +
                  numberWithCommas(niceData[2]["Measure Values"]) +
                  "</td></tr>";
              } else {
                tableStr += "<td>CTSTR</td></tr>";
              }
              tableStr += "<tr><th>Known Public ECE Participation</th>";
              if (niceData[1]["Measure Values"] > 9) {
                tableStr +=
                  "<td>" +
                  numberWithCommas(niceData[1]["Measure Values"]) +
                  "</td></tr>";
              } else {
                tableStr += "<td>CTSTR</td></tr>";
              }
              tableStr += "<tr><th>% No ECE Data Available</th>";
              if (Math.round(niceData[0]["Measure Values"] * 100) > 0) {
                tableStr +=
                  "<td>" +
                  Math.round(niceData[0]["Measure Values"] * 100) +
                  "%</td></tr></tbody></table>";
              } else {
                tableStr += "<td>CTSTR</td></tr></tbody></table>";
              }
            } else {
              tableStr =
                '<table class="dsTable" style="border: 0"><caption>ECE Participation Summary</caption> <tr> <td style="border: 0">No Data Available</td></tr></table>';
            }

            $("#ch3aTable5").html(tableStr);
          } else if (sh == "Racial Mix") {
            niceData.sort(
              sort_by("Federal Race Definition", true, function (a) {
                return a.toUpperCase();
              })
            );
            if (niceData.length > 0) {
              tableStr =
                '<table class="dsTable"><caption>Known ECE Participation by Race</caption> <tr> <th width="85px">Federal Race Definition</th> <th width="30px">ECE Participation</th> </tr>';
              for (i = 0; i < niceData.length; i++) {
                tableStr +=
                  "<tr><td>" + niceData[i]["Federal Race Definition"] + "</td>";
                if (
                  Math.round(
                    niceData[i]["SUM(Known Public ECE Participation)"] * 100
                  ) > 0
                ) {
                  tableStr +=
                    "<td>" +
                    Math.round(
                      niceData[i]["SUM(Known Public ECE Participation)"] * 100
                    ) +
                    "%</td></tr>";
                } else {
                  tableStr += "<td>CTSTR</td></tr>";
                }
              }
              tableStr += "</table>";
            } else {
              tableStr =
                '<table class="dsTable" style="border: 0"><caption>Known ECE Participation by Race</caption> <tr> <td style="border: 0">No Data Available</td></tr></table>';
            }

            $("#ch3aTable6").html(tableStr);
          } else if (sh == "CCAP") {
            niceData.sort(
              sort_by("Federal Race Color", true, function (a) {
                return a.toUpperCase();
              })
            );
            if (niceData.length > 0) {
              tableStr =
                '<table class="dsTable"><caption>Child Care Assistance (CCAP)</caption> <tr> <th width="85px">Federal Race Definition</th> <th width="30px">CCAP</th> </tr>';
              for (i = 0; i < niceData.length; i++) {
                tableStr +=
                  "<tr><td>" + niceData[i]["Federal Race Color"] + "</td>";
                if (niceData[i]["AGG(CCAP (Suppressed))"] > 9) {
                  tableStr +=
                    "<td>" +
                    numberWithCommas(niceData[i]["AGG(CCAP (Suppressed))"]) +
                    "</td></tr>";
                } else {
                  tableStr += "<td>CTSTR</td></tr>";
                }
              }
              tableStr += "</table>";
            } else {
              tableStr =
                '<table class="dsTable" style="border: 0"><caption>Child Care Assistance (CCAP)</caption> <tr> <td style="border: 0">No Data Available</td></tr></table>';
            }

            $("#ch3aTable2").html(tableStr);
          } else if (sh == "ECSE") {
            niceData.sort(
              sort_by("Federal Race Color", true, function (a) {
                return a.toUpperCase();
              })
            );
            if (niceData.length > 0) {
              tableStr =
                '<table class="dsTable"><caption>Early Childhood Special Education (ECSE)</caption> <tr> <th width="85px">Federal Race Definition</th> <th width="30px">ECSE</th> </tr>';
              for (i = 0; i < niceData.length; i++) {
                tableStr +=
                  "<tr><td>" + niceData[i]["Federal Race Color"] + "</td>";
                if (niceData[i]["AGG(ECSE (Suppressed))"] > 9) {
                  tableStr +=
                    "<td>" +
                    numberWithCommas(niceData[i]["AGG(ECSE (Suppressed))"]) +
                    "</td></tr>";
                } else {
                  tableStr += "<td>CTSTR</td></tr>";
                }
              }
              tableStr += "</table>";
            } else {
              tableStr =
                '<table class="dsTable" style="border: 0"><caption>Early Childhood Special Education (ECSE)</caption> <tr> <td style="border: 0">No Data Available</td></tr></table>';
            }

            $("#ch3aTable3").html(tableStr);
          } else if (sh == "MN District Pre-K") {
            niceData.sort(
              sort_by("Federal Race Color", true, function (a) {
                return a.toUpperCase();
              })
            );
            if (niceData.length > 0) {
              tableStr =
                '<table class="dsTable"><caption>MN District Pre-School</caption> <tr> <th width="85px">Federal Race Definition</th> <th width="30px">MN District Pre-K</th> </tr>';
              for (i = 0; i < niceData.length; i++) {
                tableStr +=
                  "<tr><td>" + niceData[i]["Federal Race Color"] + "</td>";
                if (niceData[i]["AGG(MN Pre-K (Suppressed))"] > 9) {
                  tableStr +=
                    "<td>" +
                    numberWithCommas(
                      niceData[i]["AGG(MN Pre-K (Suppressed))"]
                    ) +
                    "</td></tr>";
                } else {
                  tableStr += "<td>CTSTR</td></tr>";
                }
              }
              tableStr += "</table>";
            } else {
              tableStr =
                '<table class="dsTable" style="border: 0"><caption>MN District Pre-School</caption> <tr> <td style="border: 0">No Data Available</td></tr></table>';
            }

            $("#ch3aTable4").html(tableStr);
          } else if (sh == "ECFE") {
            niceData.sort(
              sort_by("Federal Race Color", true, function (a) {
                return a.toUpperCase();
              })
            );
            if (niceData.length > 0) {
              tableStr =
                '<table class="dsTable"><caption>Early Childhood Family Education (ECFE)</caption> <tr> <th width="85px">Federal Race Color</th> <th width="30px">ECFE</th></tr>';
              for (i = 0; i < niceData.length; i++) {
                tableStr +=
                  "<tr><td>" + niceData[i]["Federal Race Color"] + "</td>";
                if (niceData[i]["AGG(ECFE (Suppressed))"] > 9) {
                  tableStr +=
                    "<td>" +
                    numberWithCommas(niceData[i]["AGG(ECFE (Suppressed))"]) +
                    "</td></tr>";
                } else {
                  tableStr += "<td>CTSTR</td></tr>";
                }
              }
              tableStr += "</table>";
            } else {
              tableStr =
                '<table class="dsTable" style="border: 0"><caption>Early Childhood Family Education (ECFE)</caption> <tr> <td style="border: 0">No Data Available</td></tr></table>';
            }

            $("#ch3aTable1").html(tableStr);
          }
        } else if (chId == "ch3b") {
          if (sh == "Food and Economic Assistance Summary") {
            if (niceData.length > 0) {
              tableStr =
                '<table class="dsTable"><caption>Economic and Food Assistance Summary</caption>';
              tableStr += "<tr><td>All Kindergartners</td>";
              if (niceData[3]["Measure Values"] > 9) {
                tableStr +=
                  "<td>" +
                  numberWithCommas(niceData[3]["Measure Values"]) +
                  "</td></tr>";
              } else {
                tableStr += "<td>CTSTR</td></tr>";
              }

              tableStr += "<tr><td>MFIP/DWP</td>";
              if (niceData[2]["Measure Values"] > 9) {
                tableStr +=
                  "<td>" +
                  numberWithCommas(niceData[2]["Measure Values"]) +
                  "</td></tr>";
              } else {
                tableStr += "<td>CTSTR</td></tr>";
              }

              tableStr += "<tr><td>Food Assistance Only (No MFIP/DWP)</td>";
              if (niceData[1]["Measure Values"] > 9) {
                tableStr +=
                  "<td>" +
                  numberWithCommas(niceData[1]["Measure Values"]) +
                  "</td></tr>";
              } else {
                tableStr += "<td>CTSTR</td></tr>";
              }

              tableStr += "<tr><td>No MFIP or Food Assistance</td>";
              if (niceData[0]["Measure Values"] > 9) {
                tableStr +=
                  "<td>" +
                  numberWithCommas(niceData[0]["Measure Values"]) +
                  "</td></tr>";
              } else {
                tableStr += "<td>CTSTR</td></tr>";
              }
              tableStr += "</table>";
            } else {
              tableStr =
                '<table class="dsTable" style="border: 0"><caption>Economic and Food Assistance Summary</caption> <tr> <td style="border: 0">No Data Available</td></tr></table>';
            }
            $("#ch3bTable5").html(tableStr);
          } else if (sh == "Food and Econ Assistance Pie") {
            /* else if (sh == "Food and Econ Assistance") {
                                                   niceData.sort(sort_by('Food Assistance Populations', true, function (a) {
                                                       return a.toUpperCase();
                                                   }));
                                                   if (niceData.length > 0) {
                                                       tableStr = '<table class="dsTable"><caption>Breakdown by Program</caption> <tr><th>Food Assistance Population</th> <th width="85px">Program</th>  <th width="62px">Count </th></tr>';
                                                       for (i = 0; i < niceData.length; i++) {
                                                           tableStr += "<tr><td>" + niceData[i]["Food Assistance Populations"] + "</td><td>" + niceData[i]["Program"] + "</td>";
                                                           if (niceData[i]["SUM(PersonCount)"] > 9) {
                                                               tableStr += "<td>" + numberWithCommas(niceData[i]["SUM(PersonCount)"]) + "</td></tr>";
                                                           } else {
                                                               tableStr += "<td>CTSTR</td></tr>";
                                                           }

                                                       }
                                                       tableStr += "</table>";
                                                   } else {
                                                       tableStr = '<table class="dsTable" style="border: 0"><caption>Breakdown by Program</caption> <tr> <td style="border: 0">No Data Available</td></tr></table>';
                                                   }
                                                   $("#ch3bTable6").html(tableStr);
                                               } */
            niceData.sort(
              sort_by("Food Assistance Populations", true, function (a) {
                return a.toUpperCase();
              })
            );
            if (niceData.length > 0) {
              tableStr =
                '<table class="dsTable"><caption>Breakdown by Type of Assistance</caption> <tr> <th width="85px">Food Assistance Population</th>  <th width="62px">Count </th></tr>';
              for (i = 0; i < niceData.length; i++) {
                tableStr +=
                  "<tr><td>" +
                  niceData[i]["Food Assistance Populations"] +
                  "</td>";
                if (niceData[i]["SUM(All Kindergartners)"] > 9) {
                  tableStr +=
                    "<td>" +
                    numberWithCommas(niceData[i]["SUM(All Kindergartners)"]) +
                    "</td></tr>";
                } else {
                  tableStr += "<td>CTSTR</td></tr>";
                }
              }
              tableStr += "</table>";
            } else {
              tableStr =
                '<table class="dsTable" style="border: 0"><caption>Breakdown by Type of Assistance</caption> <tr> <td style="border: 0">No Data Available</td></tr></table>';
            }
            $("#ch3bTable7").html(tableStr);
          } else if (sh == "CCAP-Food Assistance") {
            niceData.sort(
              sort_by("Food Assistance Populations", true, function (a) {
                return a.toUpperCase();
              })
            );
            if (niceData.length > 0) {
              tableStr =
                '<table class="dsTable"><caption>CCAP</caption> <tr> <th width="85px">Food Assistance Population</th>  <th width="62px">Count </th></tr>';
              for (i = 0; i < niceData.length; i++) {
                tableStr +=
                  "<tr><td>" +
                  niceData[i]["Food Assistance Populations"] +
                  "</td>";
                if (niceData[i]["AGG(CCAP (Suppressed))"] > 9) {
                  tableStr +=
                    "<td>" +
                    numberWithCommas(niceData[i]["AGG(CCAP (Suppressed))"]) +
                    "</td></tr>";
                } else {
                  tableStr += "<td>CTSTR</td></tr>";
                }
              }
              tableStr += "</table>";
            } else {
              tableStr =
                '<table class="dsTable" style="border: 0"><caption>CCAP</caption> <tr> <td style="border: 0">No Data Available</td></tr></table>';
            }
            $("#ch3bTable6").html(tableStr);
          } else if (sh == "ECFE-Food Assistance") {
            niceData.sort(
              sort_by("Food Assistance Populations", true, function (a) {
                return a.toUpperCase();
              })
            );
            if (niceData.length > 0) {
              tableStr =
                '<table class="dsTable"><caption>ECFE</caption> <tr> <th width="85px">Food Assistance Population</th>  <th width="62px">Count </th></tr>';
              for (i = 0; i < niceData.length; i++) {
                tableStr +=
                  "<tr><td>" +
                  niceData[i]["Food Assistance Populations"] +
                  "</td>";
                if (niceData[i]["AGG(ECFE (Suppressed))"] > 9) {
                  tableStr +=
                    "<td>" +
                    numberWithCommas(niceData[i]["AGG(ECFE (Suppressed))"]) +
                    "</td></tr>";
                } else {
                  tableStr += "<td>CTSTR</td></tr>";
                }
              }
              tableStr += "</table>";
            } else {
              tableStr =
                '<table class="dsTable" style="border: 0"><caption>ECFE</caption> <tr> <td style="border: 0">No Data Available</td></tr></table>';
            }
            $("#ch3bTable3").html(tableStr);
          } else if (sh == "ECSE-Food Assistance") {
            niceData.sort(
              sort_by("Food Assistance Populations", true, function (a) {
                return a.toUpperCase();
              })
            );
            if (niceData.length > 0) {
              tableStr =
                '<table class="dsTable"><caption>ECSE</caption> <tr> <th width="85px">Food Assistance Population</th>  <th width="62px">Count </th></tr>';
              for (i = 0; i < niceData.length; i++) {
                tableStr +=
                  "<tr><td>" +
                  niceData[i]["Food Assistance Populations"] +
                  "</td>";
                if (niceData[i]["AGG(ECSE (Suppressed))"] > 9) {
                  tableStr +=
                    "<td>" +
                    numberWithCommas(niceData[i]["AGG(ECSE (Suppressed))"]) +
                    "</td></tr>";
                } else {
                  tableStr += "<td>CTSTR</td></tr>";
                }
              }
              tableStr += "</table>";
            } else {
              tableStr =
                '<table class="dsTable" style="border: 0"><caption>ECSE</caption> <tr> <td style="border: 0">No Data Available</td></tr></table>';
            }
            $("#ch3bTable2").html(tableStr);
          } else if (sh == "Pre-K-Food Assistance") {
            niceData.sort(
              sort_by("Food Assistance Populations", true, function (a) {
                return a.toUpperCase();
              })
            );
            if (niceData.length > 0) {
              tableStr =
                '<table class="dsTable"><caption>District Pre-k</caption> <tr> <th width="85px">Food Assistance Population</th>  <th width="62px">Count </th></tr>';
              for (i = 0; i < niceData.length; i++) {
                tableStr +=
                  "<tr><td>" +
                  niceData[i]["Food Assistance Populations"] +
                  "</td>";
                if (niceData[i]["AGG(MN Pre-K (Suppressed))"] > 9) {
                  tableStr +=
                    "<td>" +
                    numberWithCommas(
                      niceData[i]["AGG(MN Pre-K (Suppressed))"]
                    ) +
                    "</td></tr>";
                } else {
                  tableStr += "<td>CTSTR</td></tr>";
                }
              }
              tableStr += "</table>";
            } else {
              tableStr =
                '<table class="dsTable" style="border: 0"><caption>District Pre-k</caption> <tr> <td style="border: 0">No Data Available</td></tr></table>';
            }
            $("#ch3bTable1").html(tableStr);
          } else if (sh == "No ECE Data-Food Assistance") {
            niceData.sort(
              sort_by("Food Assistance Populations", true, function (a) {
                return a.toUpperCase();
              })
            );
            if (niceData.length > 0) {
              tableStr =
                '<table class="dsTable"><caption>No ECE Data Available</caption> <tr> <th width="85px">Food Assistance Population</th>  <th width="62px">Count </th></tr>';
              for (i = 0; i < niceData.length; i++) {
                tableStr +=
                  "<tr><td>" +
                  niceData[i]["Food Assistance Populations"] +
                  "</td>";
                if (
                  niceData[i]["AGG(No ECE Data Available (Suppressed))"] > 9
                ) {
                  tableStr +=
                    "<td>" +
                    numberWithCommas(
                      niceData[i]["AGG(No ECE Data Available (Suppressed))"]
                    ) +
                    "</td></tr>";
                } else {
                  tableStr += "<td>CTSTR</td></tr>";
                }
              }
              tableStr += "</table>";
            } else {
              tableStr =
                '<table class="dsTable" style="border: 0"><caption>No ECE Data Available</caption> <tr> <td style="border: 0">No Data Available</td></tr></table>';
            }
            $("#ch3bTable4").html(tableStr);
          }
        } else if (chId == "ch4a") {
          if (sh == "Poverty - Racial Mix") {
            niceData.sort(
              sort_by("Federal Race Definition", true, function (a) {
                return a.toUpperCase();
              })
            );

            if (niceData.length > 0) {
              tableStr =
                '<table class="dsTable"><caption>Known vs Unknown - by Racial Group</caption> <tr> <th width="85px">Racial Group</th> <th width="30px">Known ECE Participation</th> <th width="62px">No ECE Data Available</th></tr>';
              for (i = 0; i < niceData.length; i++) {
                tableStr +=
                  "<tr><td>" + niceData[i]["Federal Race Definition"] + "</td>";
                if (niceData[i]["Participation"] == "Known ECE Participation") {
                  tableStr +=
                    "<td>" +
                    Math.round(niceData[i]["SUM(Person Count)"] * 100) +
                    "%</td>";
                  if (
                    niceData[i]["Federal Race Definition"] ==
                    niceData[i + 1]["Federal Race Definition"]
                  ) {
                    tableStr +=
                      "<td>" +
                      Math.round(niceData[++i]["SUM(Person Count)"] * 100) +
                      "%</td></tr>";
                  } else {
                    tableStr += "<td>CTSTR</td></tr>";
                  }
                } else {
                  tableStr +=
                    "<td>CTSTR</td><td>" +
                    Math.round(niceData[i]["SUM(Person Count)"] * 100) +
                    "%</td></tr>";
                }
              }
              tableStr += "</table>";
            } else {
              tableStr =
                '<table class="dsTable" style="border: 0"><caption>Known vs Unknown - by Racial Group</caption> <tr> <td style="border: 0">No Data Available</td></tr></table>';
            }
            $("#ch4aTable1").html(tableStr);
          } else if (sh == "Poverty - Recap") {
            niceData.sort(
              sort_by("Poverty Label", true, function (a) {
                return a.toUpperCase();
              })
            );
            if (niceData.length > 0) {
              tableStr =
                '<table class="dsTable"><caption>Known vs Unknown - by Poverty Level</caption> <tr> <th width="85px">Poverty Level</th> <th width="30px">Known ECE Participation</th> <th width="62px">No ECE Data Available</th></tr>';
              for (i = 0; i < niceData.length; i++) {
                tableStr += "<tr><td>" + niceData[i]["Poverty Label"] + "</td>";
                if (niceData[i]["Participation"] == "Known ECE Participation") {
                  tableStr +=
                    "<td>" +
                    Math.round(niceData[i]["SUM(Person Count)"] * 100) +
                    "%</td>";
                  if (
                    niceData[i]["Poverty Label"] ==
                    niceData[i + 1]["Poverty Label"]
                  ) {
                    tableStr +=
                      "<td>" +
                      Math.round(niceData[++i]["SUM(Person Count)"] * 100) +
                      "%</td></tr>";
                  } else {
                    tableStr += "<td>CTSTR</td></tr>";
                  }
                } else {
                  tableStr +=
                    "<td>CTSTR</td><td>" +
                    Math.round(niceData[i]["SUM(Person Count)"] * 100) +
                    "%</td></tr>";
                }
              }
              tableStr += "</table>";
            } else {
              tableStr =
                '<table class="dsTable" style="border: 0"><caption>Known vs Unknown - by Poverty Level</caption> <tr> <td style="border: 0">No Data Available</td></tr></table>';
            }
            $("#ch4aTable2").html(tableStr);
          } else if (sh == "Summary - Pie") {
            if (niceData.length > 0) {
              tableStr =
                '<table class="dsTable" id="ch4aSummTable"><caption>Known vs Unknown - All Students Group</caption><tbody><tr><th>% Known ECE Participation</th><td>' +
                Math.round(niceData[0]["SUM(Person Count)"] * 100) +
                "%</td></tr><tr><th >% No ECE Data Available</th><td>" +
                Math.round(niceData[1]["SUM(Person Count)"] * 100) +
                "%</td></tr></tbody></table>";
            } else {
              tableStr =
                '<table class="dsTable" style="border: 0"><caption>Known vs Unknown - All Students Group</caption> <tr> <td style="border: 0">No Data Available</td></tr></table>';
            }
            $("#ch4aTable3").html(tableStr);
          } else if (sh == "Summary - Data") {
            var t = "<tr><th>All Kindergartners</th>";
            if (niceData[2]["Measure Values"] > 9) {
              t +=
                "<td>" +
                numberWithCommas(niceData[2]["Measure Values"]) +
                "</td>";
            } else {
              t += "<td>CTSTR</td>";
            }
            t += "</tr><tr><th>Known ECE Participation</th>";

            if (niceData[1]["Measure Values"] > 9) {
              t +=
                "<td>" +
                numberWithCommas(niceData[1]["Measure Values"]) +
                "</td></tr>";
            } else {
              t += "<td>CTSTR</td></tr>";
            }
            $("#ch4aSummTable").prepend(t);
          }
        } else if (chId == "ch5a") {
          if (sh == "Poverty - MFIP/Food Assist") {
            if (niceData.length > 0) {
              tableStr =
                '<table class="dsTable"><caption>MFIP/DWP and Food Assistance Trend</caption> <tr> <th width="85px">Program</th> <th width="30px">Year</th> <th width="62px">Count</th></tr>';
              for (i = 0; i < niceData.length; i++) {
                if (
                  niceData[i]["Measure Names"] ==
                  "[sqlproxy.0pnb68v1rksldp12cfuqp0k3vhdk].[usr:MFIP/DWP (copy):qk]"
                ) {
                  tableStr +=
                    "<tr><td>MFIP/DWP</td><td>" +
                    niceData[i]["YEAR(Fiscal Year Date)"] +
                    "</td><td>";
                  if (niceData[i]["Measure Values"] > 9) {
                    tableStr +=
                      numberWithCommas(niceData[i]["Measure Values"]) +
                      "</td></tr>";
                  } else {
                    tableStr += "CTSTR</td></tr>";
                  }
                } else if (
                  niceData[i]["Measure Names"] ==
                  "[sqlproxy.0pnb68v1rksldp12cfuqp0k3vhdk].[usr:Calculation_762515730287341572:qk]"
                ) {
                  tableStr +=
                    "<tr><td>No MFIP or Food Assistance</td><td>" +
                    niceData[i]["YEAR(Fiscal Year Date)"] +
                    "</td><td>";
                  if (niceData[i]["Measure Values"] > 9) {
                    tableStr +=
                      numberWithCommas(niceData[i]["Measure Values"]) +
                      "</td></tr>";
                  } else {
                    tableStr += "CTSTR</td></tr>";
                  }
                } else if (
                  niceData[i]["Measure Names"] ==
                  "[sqlproxy.0pnb68v1rksldp12cfuqp0k3vhdk].[usr:Calculation_762515730286288899:qk]"
                ) {
                  tableStr +=
                    "<tr><td>Food Assistance Only (no MFIP/DWP)</td></td><td>" +
                    niceData[i]["YEAR(Fiscal Year Date)"] +
                    "</td><td>";

                  if (niceData[i]["Measure Values"] > 9) {
                    tableStr +=
                      numberWithCommas(niceData[i]["Measure Values"]) +
                      "</td></tr>";
                  } else {
                    tableStr += "CTSTR</td></tr>";
                  }
                }
              }
              tableStr += "</table>";
            } else {
              tableStr =
                '<table class="dsTable" style="border: 0"><caption>Known vs Unknown - All Students Group</caption> <tr> <td style="border: 0">No Data Available</td></tr></table>';
            }
            $("#ch5aTable3").html(tableStr);
          }
        }
      }

      window.topicArray = {
        topicdescription: [
          "FOC_NONE",
          "Child risk factors",
          "Hispanic or Latino",
          "Home computer availability",
          "Home internet access in 2013",
          "Home internet access in 2014",
          "Home internet access in 2015",
          "Home language spoken %26 householder English language ability",
          "Home plumbing and kitchen status",
          "Home tribal lands status",
          "Householder active military duty status",
          "Householder difficulty with independent living",
          "Householder employment status",
          "Householder hearing difficulty",
          "Householder highest education earned",
          "Householder industry of employment",
          "Householder insurance coverage status",
          "Householder language spoken at home",
          "Householder moved residence in last year",
          "Householder time leaving to go to work",
          "Householder total travel time to work",
          "Householder transportation type",
          "Householder vision difficulty",
          "Housing costs as percent of household income",
          "Number of weeks worked by householder in past year",
          "Population",
          "Poverty",
          "Race",
          "Relation to Household",
          "Rent as percent of household income",
          "Sex",
          "Size of Family",
          "Vehicles available %26 number of workers in home",
        ],
        summarytext: [
          "",
          "Children living with specific income and parent factors. Income factor is income < 200% poverty.  Parent factors include incomplete kitchen or plumbing, householder as English learner or with vision, hearing, or independent living difficulties (dressing, bathing, running errands or any other challenge) and householder with less than a high school degree. Provides estimates for children with income  and parent factors, with income or parent factor, but not both, and with no factor for households with children under age 6.",
          "Hispanic or Latino status of children.  Provides estimates of not Hispanic or Latino, Hispanic or Latino, Mexican, Puerto Rican, Cuban, Dominican, Central American, South American or Other Hispanic or Latino status for children under age 6.",
          "Availability of computer in the household. Provides estimates for access to one or more computer devices (including desktop, laptop, smartphone, or tablet) or no computer for households with children under age 6.",
          "Availability of Internet in the household. Provides estimates for households having access with an Internet subscription, having access to Internet without a subscription and having no Internet access for households with children under age 6.",
          "Availability of Internet in the household. Provides estimates for households having access with an Internet subscription, having access to Internet without a subscription and having no Internet access for households with children under age 6.",
          "Availability of Internet in the household. Provides estimates for households having access with an Internet subscription, having access to Internet without a subscription and having no Internet access for households with children under age 6.",
          "English language ability of householder (Person 1). Provides estimates for householders who speak only English at home, speak a language other than English, speaks English very well and speaks English less than very well for households with children under age 6.",
          "Availability of complete plumbing and kitchen facilities in home. Provides estimates for households with and without complete plumbing and kitchen facilities for households with children under age 6.",
          "Households residing on tribal lands. Provides estimates for households on tribal lands (including organized areas) and not on tribal lands for households with children under age 6. (This includes reservations, trust lands, Hawaii homelands, Oklahoma tribal areas, Alaska Native tribal statistical area, tribal statistical areas, State Indian reservations.)",
          "Military active duty status of householder (Person 1). Provides estimates for member of active duty military, veteran, or non-veteran status for households with children under age 6.",
          "Independent living difficulty of householder (Person 1). Provides estimates for householders with and without difficulty with independent living in households with children under age 6.",
          "Employment status of householder (Person 1). Provides estimates for employment status for unemployed, employed (including Armed Forces), and not in the labor force for households with children under age 6.",
          "Hearing status of householder (Person 1). Provides estimates for householders with and without hearing difficulty for households with children under age 6.",
          "Education attainment status of householder (Person 1). Provides estimates for education levels less than 9th grade, 9th to 12th grade (no diploma), high school graduate, some college (no degree), Associate's degree, Bachelor's degree, Graduate or professional degree for households with children under age 6.",
          "Industry of employment of householder (Person 1). Provides estimates for householders employed in manufacturing, wholesale trade, retain trade and all other industries for households with children under age 6.",
          "Health insurance status of householder (Person 1). Provides estimates for householders with and without health insurance coverage for households with children under age 6.",
          "Languages spoken in the home (selected). Provides estimates for Spanish or Spanish Creole, Chinese, Tagalog, Vietnamese, French (including Patois, Creole, Cajun), Korean, Arabic and all other languages for households with children under age 6.",
          "Householder's (Person 1) residence change in the last year. Provides estimates for householders residing in the same home one year ago or householders that moved within the United States or Puerto Rico or from abroad for households with children under age 6.",
          "Time leaving to go to work for householder (Person 1). Provides estimates of leaving times for 12:00 a.m. to 4:59 a.m., 5:00 a.m. to 5:59 a.m., 6:00 a.m. to 6:59 a.m., 7:00 a.m. to 7:59 a.m., 8:00 a.m. to 8:59 a.m., 9:00 a.m. to 9:59 a.m., 10:00 a.m. to 11:59 a.m., 12:00 p.m. to 3:59 p.m., 4:00 p.m. to 11:59 p.m. for households with children under age 6.",
          "The amount of time to work for householders.  Provides estimates of commute times for employed householders for less than a half-hour, half-hour to one hour and over one hour for households with children under age 6.",
          "Householder (Person 1) means of transportation. Provides estimates for private transportation (includes taxicabs) or public means (excludes taxicabs) for households with children under age 6.",
          "Vision status of householder (Person 1). Provides estimates for householders with and without vision difficulty for households with children under age 6.",
          "Home ownership costs as a percentage of household income. Provides estimates of monthly owner costs as a percentage of income for below 30%, 30 - 39%, 40% and above, or not computed for households with children under age 6.",
          "Number of weeks worked in past year by householder (Person 1). Provides estimates for householders who worked 50 - 52 weeks, 27 - 49 weeks, and 1 - 26 weeks for households with children under age 6.",
          "Estimates of children under age 6 for age groups 0 and 1 year, 2 and 3 years, and 4 and 5 years.",
          "Household poverty status. Provides estimates for family income up to 200% poverty and family income up to 100% poverty for households with children under age 6.",
          "Race of child. Provides estimates for races white alone, Black or African American alone, American Indian or Alaska Native alone, Asian alone, Native Hawaiian and Other Pacific Islander alone, some other race alone and two or more races for children under age 6.",
          "Relationship of child under age 6 to householder (Person 1). Provides estimates for householder's own biological, adopted, stepchild, grandchild, other relative, or foster child or unrelated child for households with children under age 6.",
          "Rent as a percent of household income. Provides estimates for gross rent as a percent of household income for below 30%, 30 - 39%, and 40% and above for households with children under age 6.",
          "Sex of child. Provides estimates for sex of child, male and female, for households with children under age 6.",
          "Household sizes. Estimates for 2-person, 3-person, 4-person, 5-person, 6-person and 7-persons or more for households with children under age 6.",
          "Number of vehicles and workers in households.  Provides estimates for no workers in the household or one or more workers in the household by the presence or absence of vehicles for households with children under age 6.",
        ],
      };

      function getTopic(tValue) {
        for (var i = 0; i < topicArray.topicdescription.length; i++) {
          if (topicArray.topicdescription[i] == tValue) {
            return topicArray.summarytext[i];
          }
        }
      }

      var $loading = $("#yrLoad"); //.hide();
      $(document)
        .ajaxStart(function () {
          $loading.show();
        })
        .ajaxStop(function () {
          $loading.hide();
        });

      window.geogQuery = function () {
        $("#topic").empty();
        $("#topic").change();
        $("#years").empty();
        $("#years").change();
        if ($("#geography").val() == "County") {
          $("#topicDescription").empty();
          $("#ctyField").show();
          if ($("#states").val() == "FOC_NONE") {
            $("[id=states]").val("");
            $("#states").change();
          }
          $('#states option[value="FOC_NONE"]').remove();
          ctyQuery();
        } else {
          $("#topicDescription").empty();
          $("#counties").val("").change();
          $("#ctyField").hide();
          $('#states option[value=""]').remove();
          $("#states").prepend('<option value="FOC_NONE">All States</option>');
          $("#states").prepend('<option value=""></option>');
        }
      };
      window.ctyQuery = function () {
        if ($("#geography").val() == "County") {
          if ($("#states").val() != "") {
            var ctyUrl =
              "/ibi_apps/WFServlet?IBIAPP_app=ECLDSwebsvc&IBIF_ex=ecldsws_getdata_filter_census_county.fex";
            ctyUrl += "&STATE=" + $("#states").val();
            $.getJSON(ctyUrl, function (data) {
              var ctyRows = data.dataSets.census.data.rows;
              var options = "";

              $("#counties").empty();
              for (i = 0; i < ctyRows.length; i++) {
                options +=
                  '<option value="' +
                  ctyRows[i].county +
                  '">' +
                  ctyRows[i].county +
                  "</option>";
              }
              $("#counties").append(options);
              $('#counties option[value=""]').remove();
              $("#counties").prepend(
                '<option value="FOC_NONE">All Counties</option>'
              );
              $("#counties").prepend('<option value=""></option>');
              $("[id=counties]").val("");
              $("#counties").change();
            });
          } else {
            $("#censusTable").html("");
            $("[id=counties]").val("");
            $("#counties").change();
          }
        } else {
          if ($("#states").val() != "") {
            $("#years").empty();
            $("#years").prepend('<option value=""></option>');
            $("[id=years]").val("");
            $("#years").change();
            var yearsUrl =
              "/ibi_apps/WFServlet?IBIAPP_app=ECLDSwebsvc&IBIF_ex=ecldsws_getdata_filter_census_year.fex"; // &STATE=Texas&COUNTY=FOC_NONE
            yearsUrl += "&STATE=" + $("#states").val() + "&COUNTY=FOC_NONE";
            $.getJSON(yearsUrl, function (data) {
              var options = "";
              var years = data.years;

              $("#years").empty();
              for (i = 0; i < years.length; i++) {
                options +=
                  '<option value="' +
                  years[i].year +
                  '">' +
                  years[i].year +
                  "</option>";
              }
              $("#years").append(options);
              $('#years option[value=""]').remove();
              $("#years").prepend('<option value=""></option>');
              $("[id=years]").val("");
              $("#years").change();
            });
          }
        }
      };
      /*  window.ch3Query = function (query) {
         console.log(query);
         var b = query.replace(/'/g, '"');
         var p = JSON.parse(b);
         console.log(p);
         var pId = p.id.slice(0, -5);
         pId = pId.substring(1) + 1;
         console.log(pId);
         var ch3Url =
           "/ibi_apps/WFServlet?IBIAPP_app=ECLDSwebsvc&IBIF_ex=ecldsws_getdata_economicfoodassistance.fex&orgId=" +
           pId +
           "&FISCAL_YEAR=2022";
 
         //&ECO_DEV_REGION=FOC_NONE&FISCAL_YEAR=2022&DISABILITY_TYPE=FOC_NONE&HOME_LANGUAGE=FOC_NONE";
         ///ibi_apps/WFServlet?IBIAPP_app=ECLDSwebsvc&IBIF_ex=ecldsws_getdata_economicfoodassistance.fex&orgId=
         //016601
         //0166001
 
         //&FISCAL_YEAR=2022
         ///ibi_apps/WFServlet?IBIAPP_app=ECLDSwebsvc&IBIF_ex=ecldsws_getdata_economicfoodassistance.fex
         //  &orgName=Cook County&orgId=10166000000&groupType=district
 
         console.log(ch3Url);
         $.getJSON(ch3Url, function (data) {
           console.log(data);
           var d = data.dataSets.familySupportProgramParticipation.data;
 
           var tableString =
             " <table class='ch3table'><thead><tr><th >Food Assistance Populations</th><th >Count</th></tr></thead><tr>";
 
           var rows = d.length;
           for (i = 0; i < rows; i++) {
             tableString +=
               "<tr><td>" +
               d[i].programName +
               "</td><td>" +
               d[i].formattedCount +
               "</td></tr>";
           }
           tableString += "</table>";
 
           $("#tableTest").replaceWith(
             "<div id='tableTest'>" + tableString + "</div>"
           );
 
           Chart = new Highcharts.Chart({
             chart: {
               renderTo: "container",
               type: "bar",
             },
             legend: { enabled: false },
             exporting: {
               buttons: {
                 contextButton: {
                   enabled: false,
                 },
               },
             },
             title: {
               text: query.name,
             },
             subtitle: {
               text: "Federal Race Definition",
             },
             credits: {
               enabled: false,
             },
             xAxis: {
               categories: [
                 "American Indian / Alaska Native",
                 "Asian",
                 "Black/African American",
                 "Hispanic / Latino of any race",
                 "Native Hawaiian / Other Pacific Islander",
                 "White",
                 "Two or More Races",
               ],
             },
             yAxis: {
               title: {
                 text: "",
               },
               min: 0,
             },
             plotOptions: {
               series: {
                 lineWidth: 2,
                 color: "#003865",
               },
               bar: {
                 dataLabels: {
                   enabled: true,
                   format: "<b>{y}</b>%",
                 },
               },
             },
             series: [
               {
                 name: "Percent",
                 data: [99.0, 7.0, 17.0, 10.1, 0, 57, 7],
               },
             ],
           });
         });
       }; */

      window.yearQuery = function () {
        if ($("#counties").val() != "") {
          $("#years").empty();
          $("#years").prepend('<option value=""></option>');
          $("[id=years]").val("");
          $("#years").change();
          var yearsUrl =
            "/ibi_apps/WFServlet?IBIAPP_app=ECLDSwebsvc&IBIF_ex=ecldsws_getdata_filter_census_year.fex"; // &STATE=Texas&COUNTY=FOC_NONE
          yearsUrl +=
            "&STATE=" + $("#states").val() + "&COUNTY=" + $("#counties").val();
          $.getJSON(yearsUrl, function (data) {
            var options = "";
            var years = data.years;

            $("#years").empty();
            for (i = 0; i < years.length; i++) {
              options +=
                '<option value="' +
                years[i].year +
                '">' +
                years[i].year +
                "</option>";
            }
            $("#years").append(options);
            $('#years option[value=""]').remove();
            $("#years").prepend('<option value=""></option>');
            $("[id=years]").val("");
            $("#years").change();
          });
        }
      };

      window.topicsQuery = function () {
        $("#topicField").show();
        $("#topic").empty();
        $("#topicDescription").empty();
        window.found = 0;

        var tUrl =
          "/ibi_apps/WFServlet?IBIAPP_app=ECLDSwebsvc&IBIF_ex=ecldsws_getdata_filter_census_year.fex"; // &STATE=Texas&COUNTY=FOC_NONE
        tUrl += "&STATE=" + $("#states").val();

        var ctySelected = $("#counties").val();
        var yrSelected = $("#years").val();
        if (ctySelected) tUrl += "&COUNTY=" + ctySelected;
        else tUrl += "&COUNTY=FOC_NONE";

        if (yrSelected != "") {
          tUrl += "&YEAR=" + yrSelected;
          $.getJSON(tUrl, function (data) {
            var years = data.years;
            for (i = 0; i < years.length; i++) {
              if (years[i].year == $("#years").val()) {
                window.found++;
                var topicRows = years[i].topics;
                var options = "";

                for (i = 0; i < topicRows.length; i++) {
                  options +=
                    '<option value="' +
                    topicRows[i].topicValue +
                    '">' +
                    topicRows[i].topicDescription +
                    "</option>";
                }
                $("#topic").append(options);
                $('#topic option[value=""]').remove();
              }
            }
            $("#topic").prepend('<option value="FOC_NONE">All Topics</option>');
            $("#topic").prepend('<option value=""></option>');
            $("[id=topic]").val("");
            $("#topic").change();
            if (window.found < 1) console.log("NO TOPICs FOUND");
          });
        }
      };

      window.popSurvey = function () {
        window.workspace.setModalInfoDialogContent(
          "<form id='feedback'><p>We like to know what you're finding useful in the system that we've built based on previous users' feedback. We also use this with our funders who are making decisions on long-term funding.</p><fieldset class='group'><legend style='font-size: 17px; font-weight: bold; padding-bottom: 4px;'>Are you using the system for <br/>(check as many as apply):</legend><div class='checkbox'><input id='resRep' type='checkbox' name='resRep' value='Yes' /><label class='notBold inline' for='resRep'>Research/reports</label></div> <div class='checkbox'><input id='commAssess' type='checkbox' name='commAssess' value='Yes' /><label class='notBold inline' for='commAssess'>Community assessments</label></div><div class='checkbox'><input id='fund' type='checkbox' name='fund' value='Yes' /><label class='notBold inline' for='fund'>Funding and/or fund raising</label></div> <div class='checkbox'><input id='exploration' type='checkbox' name='exploration' value='Yes' /><label class='notBold inline' for='exploration'>Exploration or school assignments</label></div><div class='checkbox'><input id='other' type='checkbox' name='other' value='Yes' /><label class='notBold inline' for='other'>Other (fill in)</label> <input id='otherText' type='text' name='otherText' /></div></fieldset><br/><label><strong>Is there anything else you would like us to know?</strong><br/><textarea rows='1' cols='1' size='80' name='feedbackText' style='height: 8.9em; width: 330px'></textarea><p><a href='#questionBar' data-rel='back'>No thanks, Close Window</a> <input type='hidden' name='url'  value='" +
          window.location.href +
          "'>&nbsp;&nbsp;&nbsp;<input id='subFeedback' type='submit' value='Submit'> </p></form>"
        );
        Backbone.trigger("modalOpened");
        window.workspace.showModalInfoDialog();

        $("#feedback").submit(function () {
          // tasks to do
          var formdata = $(this).serialize();

          $.ajax({
            type: "POST",
            url: "https://education.mn.gov/poll/send_ecldsFeedback_email2.php",
            data: formdata,
          });
          window.workspace.setModalInfoDialogContent(
            "<p> Thank you, your feedback has been submitted.</p><br/><a href='#questionBar' data-rel='back'> Close Window</a> "
          );

          return false;
        });
      };

      window.censusQuery = function () {
        $("#censusTable").html("");
        $("#censusDownload").html("");
        var dlUrl =
          "/ibi_apps/WFServlet?IBIAPP_app=ECLDSwebsvc&IBIF_ex=ecldsws_getdata_censusreport_excel.fex";
        var qUrl =
          "/ibi_apps/WFServlet?IBIAPP_app=ECLDSwebsvc&IBIF_ex=ecldsws_getdata_censusreport.fex";

        var tDesc = getTopic($("#topic").val());
        $("#topicDescription").html(tDesc);

        qUrl += "&STATE=" + $("#states").val();
        dlUrl += "&STATE=" + $("#states").val();
        if ($("#counties").val() != null) {
          qUrl += "&COUNTY=" + $("#counties").val();
          dlUrl += "&COUNTY=" + $("#counties").val();
        } else {
          qUrl += "&COUNTY=";
          dlUrl += "&COUNTY=";
        }
        qUrl += "&TOPIC=" + $("#topic").val();
        dlUrl += "&TOPIC=" + $("#topic").val();
        qUrl += "&YEAR=" + $("#years").val();
        dlUrl += "&YEAR=" + $("#years").val();

        if (
          $("#states").val() != "" &&
          $("#topic").val() != "" &&
          (($("#geography").val() == "County" && $("#counties").val() != "") ||
            $("#geography").val() == "State")
        ) {
          var dlString =
            "<h3>Download</h3><button onclick=\"window.open('" +
            dlUrl +
            "','_blank'); popSurvey(); return false;\" class=\"ui-btn ui-shadow ui-corner-all\">Excel Workbook</button>";
          $("#censusDownload").html(dlString);
        }

        if (
          $("#states").val() == "FOC_NONE" ||
          $("#states").val() == "" ||
          $("#years").val() == "" ||
          $("#topic").val() == "" ||
          $("#topic").val() == "FOC_NONE" ||
          ($("#geography").val() == "County" &&
            ($("#counties").val() == "FOC_NONE" || $("#counties").val() == ""))
        ) {
          console.log("No table");
        } else {
          $.getJSON(qUrl, function (data) {
            var cenRows;
            if (data.meta.dataNotAvailableMessage) {
              tableStr =
                "<strong>" + data.meta.dataNotAvailableMessage + "</strong>";
              $("#censusDownload").html("");
            } else if (data.dataSets.census.data.rows[0].censusYearRange1) {
              cenRows = data.dataSets.census.data.rows;
              console.log(cenRows);
              tableStr =
                "<table><tbody><tr>    <th>County/State/US</th>   <th>Topic Description</th>    <th>Demographic</th>    <th>Age Group</th>    <th>Estimate " +
                cenRows[0].censusYearRange1 +
                "</th> <th>Estimate " +
                cenRows[0].censusYearRange2 +
                "</th>    <th>Statistically Significant</th></tr>";

              for (i = 0; i < cenRows.length; i++) {
                tableStr +=
                  "<tr><td>" +
                  cenRows[i].geoName +
                  "</td><td>" +
                  cenRows[i].topicDescription +
                  "</td><td>" +
                  cenRows[i].demographic +
                  "</td><td>" +
                  cenRows[i].ageRange +
                  "</td><td>" +
                  cenRows[i].cestYrRange1 +
                  "</td><td>" +
                  cenRows[i].cestYrRange2 +
                  "</td><td>" +
                  cenRows[i].isSignificant +
                  "</td>" +
                  "</tr>";
              }
              tableStr += "</tbody></table>";
              $("#censusTable").html(tableStr);
            } else {
              cenRows = data.dataSets.census.data.rows;
              tableStr =
                "<table><tbody><tr>    <th>Year</th>    <th>County/State/US</th>    <th>Topic Description</th>    <th>Demographic</th>    <th>Age Group</th>    <th>Estimate</th>    <th>Measurement of Error</th></tr>";

              for (i = 0; i < cenRows.length; i++) {
                tableStr +=
                  "<tr><td>" +
                  cenRows[i].censusYear +
                  "</td><td>" +
                  cenRows[i].geoName +
                  "</td><td>" +
                  cenRows[i].topicDescription +
                  "</td><td>" +
                  cenRows[i].demographic +
                  "</td><td>" +
                  cenRows[i].ageRange +
                  "</td><td>" +
                  cenRows[i].cest +
                  "</td><td>" +
                  cenRows[i].cme +
                  "</td>" +
                  "</tr>";
              }
              tableStr += "</tbody></table>";
              $("#censusTable").html(tableStr);
            }
            $("#censusTable").html(tableStr);
          });
        }
      };

      window.reload3 = function () {
     /*    if (vizzes.ch3aViz) {
          // If a viz object exists, delete it.
          vizzes.ch3aViz.dispose();
        }
        initViz(ch3aURL, "ch3a", ch3aVizDiv, "ch3aViz"); */
      };
      window.ch1aShowTables = function () {
        $("#ch1awrap2").show();
        $("#ch1awrap1").hide();
        $("#ch1awrap2").focus();
        gtag("event", "View", {
          event_category: "Report",
          event_label: "ch1Table",
        });
      };
      window.ch1aShowCharts = function () {
        $("#ch1awrap1").show();
        $("#ch1awrap2").hide();
        $("#ch1awrap1").focus();
      };
      window.ch3aShowTables = function (id) {
        $("#ch3aTable1").show();
        $("#ch3aTable2").show();
        $("#ch3aTable3").show();
        $("#ch3aTable4").show();
        $("#ch3aTable5").show();
        $("#ch3aTable6").show();
        $("#ch3a").hide();
        $("#ch3aChButton").show();
        $("#ch3aTableButton").hide();
        gtag("event", "View", {
          event_category: "Report",
          event_label: "ch3aTable",
        });
      };
      window.ch3aShowCharts = function (id) {
        $("#ch3aTable1").hide();
        $("#ch3aTable2").hide();
        $("#ch3aTable3").hide();
        $("#ch3aTable4").hide();
        $("#ch3aTable5").hide();
        $("#ch3aTable6").hide();
        $("#ch3aTableButton").show();
        $("#ch3a").show();
        $("#ch3aChButton").hide();
      };

      window.ch3bShowTables = function (id) {
        $("#ch3bTable1").show();
        $("#ch3bTable2").show();
        $("#ch3bTable3").show();
        $("#ch3bTable4").show();
        $("#ch3bTable5").show();
        $("#ch3bTable6").show();
        $("#ch3bTable7").show();
        $("#ch3b").hide();
        $("#ch3bChButton").show();
        $("#ch3bTableButton").hide();
        gtag("event", "View", {
          event_category: "Report",
          event_label: "ch3bTable",
        });
      };
      window.ch3bShowCharts = function (id) {
        $("#ch3bTable1").hide();
        $("#ch3bTable2").hide();
        $("#ch3bTable3").hide();
        $("#ch3bTable4").hide();
        $("#ch3bTable5").hide();
        $("#ch3bTable6").hide();
        $("#ch3bTable7").hide();
        $("#ch3bTableButton").show();
        $("#ch3b").show();
        $("#ch3bChButton").hide();
      };
      window.ch3cShowTables = function () {
        $("#ch3cwrap2").show();
        $("#ch3cwrap1").hide();
        $("#ch3cwrap2").focus();
        gtag("event", "View", {
          event_category: "Report",
          event_label: "ch3cTable",
        });
      };
      window.ch3cShowCharts = function () {
        $("#ch3cwrap1").show();
        $("#ch3cwrap2").hide();
        $("#ch3cwrap1").focus();
      };
      window.ch4aShowTables = function (id) {
        $("#ch4aTable1").show();
        $("#ch4aTable2").show();
        $("#ch4aTable3").show();
        $("#ch4a").hide();
        $("#ch4aChButton").show();
        $("#ch4aTableButton").hide();
        gtag("event", "View", {
          event_category: "Report",
          event_label: "ch4Table",
        });
      };
      window.ch4aShowCharts = function (id) {
        $("#ch4aTable1").hide();
        $("#ch4aTable2").hide();
        $("#ch4aTable3").hide();
        $("#ch4aTableButton").show();
        $("#ch4a").show();
        $("#ch4aChButton").hide();
      };

      window.ch5aShowTables = function (id) {
        $("#ch5aTable1").show();
        $("#ch5aTable2").show();
        $("#ch5aTable3").show();
        $("#ch5a").hide();
        $("#ch5aChButton").show();
        $("#ch5aTableButton").hide();
        gtag("event", "View", {
          event_category: "Report",
          event_label: "ch5Table",
        });
      };
      window.ch5aShowCharts = function (id) {
        $("#ch5aTable1").hide();
        $("#ch5aTable2").hide();
        $("#ch5aTable3").hide();
        $("#ch5aTableButton").show();
        $("#ch5a").show();
        $("#ch5aChButton").hide();
      };
      window.ch6aShowTables = function () {
        $("#ch6awrap2").show();
        $("#ch6awrap1").hide();
        $("#ch6awrap2").focus();
        gtag("event", "View", {
          event_category: "Report",
          event_label: "ch6aTable",
        });
      };
      window.ch6aShowCharts = function () {
        $("#ch6awrap1").show();
        $("#ch6awrap2").hide();
        $("#ch6awrap1").focus();
      };
      window.ch6bShowTables = function () {
        $("#ch6bwrap2").show();
        $("#ch6bwrap1").hide();
        $("#ch6bwrap2").focus();
        gtag("event", "View", {
          event_category: "Report",
          event_label: "ch6bTable",
        });
      };
      window.ch6bShowCharts = function () {
        $("#ch6bwrap1").show();
        $("#ch6bwrap2").hide();
        $("#ch6bwrap1").focus();
      };

      function afterCommonSourcesLoaded() {

        $.getJSON(
          "/ibi_apps/WFServlet?IBIAPP_app=ECLDSwebsvc&IBIF_ex=ecldsws_getdata_report_availability_matrix.fex",
          function (json) {
            var tableString =
              " <table border='1' width='100%' id='matrix' class='matrix tablesorter'><thead><tr><th class='headCol headColumnSort' >Data Sources</th><th class='headCol2 headColumnSort'>Agency</th>";
            var years = json.data.years.length;
            for (i = 0; i < years; i++) {
              tableString +=
                "<th class='sorter-false'>" + json.data.years[i].year + "</th>";
            }
            tableString += "</tr></thead><tr>";

            var dataSources = json.data.dataSources.length;
            for (i = 0; i < dataSources; i++) {
              tableString +=
                "<tr ><td style='text-align:left; min-width: 250px;' class='headCol'>" +
                json.data.dataSources[i].dataSource +
                "</td><td class='headCol2'>" +
                json.data.dataSources[i].agency +
                "</td>";
              for (x = 1; x <= years; x++) {
                tableString +=
                  "<td class='" +
                  json.data.dataSources[i]["year" + x] +
                  "'>" +
                  json.data.dataSources[i]["year" + x] +
                  "</td>";
              }
              tableString += "</tr>";
            }
            tableString += "</table>";

            $("#dataMatrix").replaceWith(
              "<div id='dataMatrix'>" + tableString + "</div>"
            );
            $("#matrix").tablesorter();
          }
        );

        //initViz(ch3aURL, "ch3a", ch3aVizDiv, "ch3aViz");
        //    initViz(ch3bURL, "ch3b", ch3bVizDiv, "ch3bViz");
        //    initViz(ch4aURL, "ch4a", ch4aVizDiv, "ch4aViz");
      //  initViz(ch5aURL, "ch5a", ch5aVizDiv, "ch5aViz");

        window.settings = new Controllers.Settings();

        // set up the main workspace controller and feed it
        // dependencies, which needs to happen second because it reads
        // settings from the above settings controller
        window.workspace = new Controllers.MainWorkspaceController({
          commonDataSourceManager: commonDataSourceManager,

          // singleton view objects
          questionBarView: new BaseViews.QuestionBarView({
            el: $(".questionBar"),
            model: CommonDataSources.reportInfo,
          }),
          reportListView: new Views.ECLDSReportListView({
            container: "#navDrawer",
            model: CommonDataSources.reportInfo,
          }),

          // misc. singleton controller objects
          mapController: new Controllers.MapController(),
          bubbleMaker: new BaseViews.BubbleMaker(),

          // some needed elements on the page
          $navDrawer: $("#navDrawer"),
          $introLink: $("#introLink"),
        });

        // FOUC fix adapted from one by Mr. Paul Irish
        // http://paulirish.com/2009/avoiding-the-fouc-v3/ (thanks!)
        /* jshint white:false */ (function (H) {
          H.className = H.className.replace(/\bnotReady\b/, "ready");
        })(document.documentElement);
        window.loadingSpinner.stop();

        // instantiate the router and controller machinery! we also
        // need to set up some defaults in the jquery mobile world,
        // which is necessary because we disable its automatic
        // page-flipping so we can have backbone's routing to manage
        // client-side pages
        window.appRouter = new AppRouter();
        Backbone.history.start({
          pushState: false,
        });
        attemptingCommonSourceLoad = false;
        $(".clickEcips").click(function () {
          window.workspace.setModalInfoDialogContent(
            "The Early Childhood Indicators of Progress (ECIPs), Minnesota's Early Childhood Learning Standards, are a common set of developmentally appropriate expectations for children ages birth to kindergarten. The ECIPs are used in all areas                        of the early childhood system, as well as used in all Minnesota programs (aligned with Head Start Early Learning Outcomes Framework). This provides consistency and coherence for children, families, teachers and administrators. ECIPs parent guides offer ideas for simple activities families can do to help children gain knowledge and skills. "
          );
          Backbone.trigger("modalOpened");
          window.workspace.showModalInfoDialog();
        });
        $(".clickEls").click(function () {
          window.workspace.setModalInfoDialogContent(
            "The Minnesota Department of Education's Division of Early Learning Services supports schools, communities and districts to implement inclusive and comprehensive prenatal through 3rd grade systems aligned with World's Best Workforce. MDE's Early Learning Services Division vision is that all Minnesota children are prepared for kindergarten, proficient in 3rd grade reading and prepared for lifelong learning. To support this vision, the following strategies are implemented by Early Learning:   <ul><li>Enhance system of prenatal through Grade 3 leadership.                        <li>	Expand access to high-quality education, services and instructional time for all children.</li>                        <li>	Strengthen and align instruction, assessment and curriculum.</li>                        <li>	Support evidence-based practices for family and community engagement.</li>                        <li>	Ensure a highly skilled workforce.</li>                        <li>	Use data to inform policy, planning, practice and professional development.</li></ul>"
          );
          Backbone.trigger("modalOpened");
          window.workspace.showModalInfoDialog();
        });

        var hash = location.hash;
        var wideBox = false;

        var repName = hash.substring(0, hash.indexOf("/"));
        if (repName.length < 1) repName = hash.substring(0, 10);

        if (location.hash.indexOf("videos1") > -1) {
          gtag("event", "View", {
            event_category: "Report",
            event_label: "vid1",
          });
          $("#video1").html(
            "<video class='video-js vjs-default-skin' controls preload='auto' width='640' height='360' poster='videos/PROD046005.jpg' data-setup='{}' style='width: 640px;  height: 360px;  border: 1px solid black; '> <source src='videos/PROD046005.mp4' type='video/mp4' /> <source src='videos/PROD046005.webm' type='video/webm' /> <track kind='captions' src='videos/PROD046005.vtt' srclang='en' label='English'> </track> </video>"
          );
          $("#video2").html("");
          $("#video3").html("");
          $("#video4").html("");
          $("#video5").html("");
          $("#video6").html("");
          $("#video7").html("");
          $("#video8").html("");
          $("#video9").html("");
          $("#video0").html("");
        } else if (location.hash.indexOf("videos2") > -1) {
          gtag("event", "View", {
            event_category: "Report",
            event_label: "vid2",
          });
          $("#video2").html(
            "<video class='video-js vjs-default-skin' controls preload='auto' width='640' height='360' poster='videos/OHE_Navigating_ECLDS_Tutorial_September.jpg' data-setup='{}' style='width: 640px; height: 360px;  border: 1px solid black; '> <source src='videos/OHE_Navigating_ECLDS_Tutorial_September.mp4' type='video/mp4' /> <source src='videos/OHE_Navigating_ECLDS_Tutorial_September.webm' type='video/webm' /> <track kind='captions' src='videos/OHE_Navigating_ECLDS_Tutorial_September.vtt' srclang='en' label='English'> </track> </video>"
          );
          $("#video1").html("");
          $("#video3").html("");
          $("#video4").html("");
          $("#video5").html("");
          $("#video6").html("");
          $("#video7").html("");
          $("#video8").html("");
          $("#video9").html("");
          $("#video0").html("");
        } else if (location.hash.indexOf("videos3") > -1) {
          gtag("event", "View", {
            event_category: "Report",
            event_label: "vid3",
          });
          $("#video3").html(
            "<video class='video-js vjs-default-skin' controls preload='auto' width='640' height='360' poster='videos/PROD045771.jpg' data-setup='{}' style='width: 640px; height: 360px;  border: 1px solid black; '> <source src='videos/PROD045771.mp4' type='video/mp4' /> <source src='videos/PROD045771.webm' type='video/webm' /> <track kind='captions' src='videos/PROD045771.vtt' srclang='en' label='English'> </track> </video>"
          );
          $("#video1").html("");
          $("#video2").html("");
          $("#video4").html("");
          $("#video5").html("");
          $("#video6").html("");
          $("#video7").html("");
          $("#video8").html("");
          $("#video9").html("");
          $("#video0").html("");
        } else if (location.hash.indexOf("videos4") > -1) {
          gtag("event", "View", {
            event_category: "Report",
            event_label: "vid4",
          });
          $("#video4").html(
            "<video class='video-js vjs-default-skin' controls preload='auto' width='640' height='360' poster='videos/ECLDS_ProgramPlanning.jpg' data-setup='{}' style='width: 640px; height: 360px;  border: 1px solid black; '> <source src='videos/ECLDS_ProgramPlanning.mp4' type='video/mp4' /> <source src='videos/ECLDS_ProgramPlanning.webm' type='video/webm' /> <track kind='captions' src='videos/ECLDS_ProgramPlanning.vtt' srclang='en' label='English'> </track> </video>"
          );
          $("#video1").html("");
          $("#video2").html("");
          $("#video3").html("");
          $("#video5").html("");
          $("#video6").html("");
          $("#video7").html("");
          $("#video8").html("");
          $("#video9").html("");
          $("#video0").html("");
        } else if (location.hash.indexOf("videos5") > -1) {
          gtag("event", "View", {
            event_category: "Report",
            event_label: "vid5",
          });
          $("#video5").html(
            "<video class='video-js vjs-default-skin' controls preload='auto' width='640' height='360' poster='videos/OHE_ECLDS_DataUseToolkit.jpg' data-setup='{}' style='width: 640px; height: 360px;  border: 1px solid black; '> <source src='videos/OHE_ECLDS_DataUseToolkit.mp4' type='video/mp4' /> <source src='videos/OHE_ECLDS_DataUseToolkit.webm' type='video/webm' /> <track kind='captions' src='videos/OHE_ECLDS_DataUseToolkit.vtt' srclang='en' label='English'> </track> </video>"
          );
          $("#video1").html("");
          $("#video2").html("");
          $("#video3").html("");
          $("#video4").html("");
          $("#video6").html("");
          $("#video7").html("");
          $("#video8").html("");
          $("#video9").html("");
          $("#video0").html("");
        } else if (location.hash.indexOf("videos6") > -1) {
          gtag("event", "View", {
            event_category: "Report",
            event_label: "vid6",
          });
          $("#video6").html(
            "<video class='video-js vjs-default-skin' controls preload='auto' width='640' height='360' poster='videos/mde031978.jpg' data-setup='{}' style='width: 640px; height: 360px;  border: 1px solid black; '> <source src='videos/mde031978.mp4' type='video/mp4' /> <source src='videos/mde031978.webm' type='video/webm' /> <track kind='captions' src='videos/mde031978.vtt' srclang='en' label='English'> </track> </video>"
          );
          $("#video1").html("");
          $("#video2").html("");
          $("#video3").html("");
          $("#video4").html("");
          $("#video5").html("");
          $("#video7").html("");
          $("#video8").html("");
          $("#video9").html("");
          $("#video0").html("");
        } else if (location.hash.indexOf("videos7") > -1) {
          gtag("event", "View", {
            event_category: "Report",
            event_label: "vid7",
          });
          $("#video7").html(
            "<video class='video-js vjs-default-skin' controls preload='auto' width='640' height='360' poster='videos/mde031980.jpg' data-setup='{}' style='width: 640px; height: 360px;  border: 1px solid black; '> <source src='videos/mde031980.mp4' type='video/mp4' /> <source src='videos/mde031980.webm' type='video/webm' /> <track kind='captions' src='videos/mde031980.vtt' srclang='en' label='English'> </track> </video>"
          );
          $("#video1").html("");
          $("#video2").html("");
          $("#video3").html("");
          $("#video4").html("");
          $("#video5").html("");
          $("#video6").html("");
          $("#video8").html("");
          $("#video9").html("");
          $("#video0").html("");
        } else if (location.hash.indexOf("videos8") > -1) {
          gtag("event", "View", {
            event_category: "Report",
            event_label: "vid8",
          });
          $("#video8").html(
            "<video class='video-js vjs-default-skin' controls preload='auto' width='640' height='360' poster='videos/mde031982.jpg' data-setup='{}' style='width: 640px; height: 360px;  border: 1px solid black; '> <source src='videos/mde031982.mp4' type='video/mp4' /> <source src='videos/mde031982.webm' type='video/webm' /> <track kind='captions' src='videos/mde031982.vtt' srclang='en' label='English'> </track> </video>"
          );
          $("#video1").html("");
          $("#video2").html("");
          $("#video3").html("");
          $("#video4").html("");
          $("#video5").html("");
          $("#video7").html("");
          $("#video9").html("");
          $("#video6").html("");
          $("#video0").html("");
        } else if (location.hash.indexOf("videos9") > -1) {
          gtag("event", "View", {
            event_category: "Report",
            event_label: "vid9",
          });
          $("#video9").html(
            "<video class='video-js vjs-default-skin' controls preload='auto' width='640' height='360' poster='videos/mde031981.jpg' data-setup='{}' style='width: 640px; height: 360px;  border: 1px solid black; '> <source src='videos/mde031981.mp4' type='video/mp4' /> <source src='videos/mde031981.webm' type='video/webm' /> <track kind='captions' src='videos/mde031981.vtt' srclang='en' label='English'> </track> </video>"
          );
          $("#video1").html("");
          $("#video2").html("");
          $("#video3").html("");
          $("#video4").html("");
          $("#video5").html("");
          $("#video7").html("");
          $("#video8").html("");
          $("#video6").html("");
          $("#video0").html("");
        } else if (location.hash.indexOf("videos0") > -1) {
          gtag("event", "View", {
            event_category: "Report",
            event_label: "vid10",
          });
          $("#video0").html(
            "<video class='video-js vjs-default-skin' controls preload='auto' width='640' height='360' poster='videos/OHE_ECLDS_CommunityNeedsAssessment.jpg' data-setup='{}' style='width: 640px; height: 360px;  border: 1px solid black; '> <source src='videos/OHE_ECLDS_CommunityNeedsAssessment.mp4' type='video/mp4' /> <source src='videos/OHE_ECLDS_CommunityNeedsAssessment.webm' type='video/webm' /> <track kind='captions' src='videos/OHE_ECLDS_CommunityNeedsAssessment.vtt' srclang='en' label='English'> </track> </video>"
          );
          $("#video1").html("");
          $("#video2").html("");
          $("#video3").html("");
          $("#video4").html("");
          $("#video5").html("");
          $("#video7").html("");
          $("#video8").html("");
          $("#video6").html("");
          $("#video9").html("");
        }
        //  $('.js-accordion').accordion();

        var $accordions = $(".js-accordion");

        if ($accordions.length) {
          // init
          $accordions.each(function (index) {
            var $this = $(this);
            ($options = $this.data()),
              ($accordions_headers = $this.find(".js-accordion__header")),
              ($accordions_prefix_classes =
                $options.accordionPrefixClasses || ""),
              ($accordions_multiselectable =
                $options.accordionMultiselectable || ""),
              ($index_accordion = index + 1);

            $this.attr({
              role: "tablist",
              "aria-multiselectable": "true",
              class: $accordions_prefix_classes,
            });

            // multiselectable or not
            if ($accordions_multiselectable === "none") {
              $this.attr("aria-multiselectable", "false");
            }

            $accordions_headers.each(function (index_h) {
              var $that = $(this),
                $text = $that.text(),
                $accordion_panel = $that.next(".js-accordion__panel"),
                $index_header = index_h + 1;

              $accordion_panel.prepend(
                $that
                  .removeClass("js-accordion__header")
                  .addClass($accordions_prefix_classes + "__title")
                  .attr("tabindex", "0")
              );

              $accordion_header = $(
                '<button class="js-accordion__header ' +
                $accordions_prefix_classes +
                '__header">' +
                $text +
                "</button>"
              );
              $accordion_panel.before($accordion_header);

              $accordion_header.attr({
                "aria-controls":
                  "accordion" + $index_accordion + "_panel" + $index_header,
                "aria-expanded": "false",
                role: "tab",
                id: "accordion" + $index_accordion + "_tab" + $index_header,
                //  "tabindex": "-1",
                "aria-selected": "false",
              });
              $accordion_panel
                .attr({
                  "aria-labelledby":
                    "accordion" + $index_accordion + "_tab" + $index_header,
                  role: "tabpanel",
                  id: "accordion" + $index_accordion + "_panel" + $index_header,
                  "aria-hidden": "true",
                })
                .addClass($accordions_prefix_classes + "__panel");

              // if opened by default
              if ($that.attr("data-accordion-opened") == "true") {
                $accordion_header
                  .attr("aria-expanded", "true")
                  .removeAttr("data-accordion-opened");
                $accordion_panel.attr("aria-hidden", "false");
              }

              // init first one focusable
              if ($index_header === 1) {
                $accordion_header.removeAttr("tabindex");
              }
              // $("#accordion1_tab2").removeAttr( "tabindex" );
            });
          });
        }

        /* Events ---------------------------------------------------------------------------------------------------------- */
        /* click on a tab link */
        $("body")
          .on("focus", ".js-accordion__header", function (event) {
            var $this = $(this),
              $accordion = $this.parent(),
              $all_accordion_headers = $accordion.find(".js-accordion__header");

            // selected
            $all_accordion_headers.attr({
              tabindex: "-1",
              "aria-selected": "false",
            });
            $this.attr("aria-selected", "true").removeAttr("tabindex");
          })
          .on("click", ".js-accordion__header", function (event) {
            var $this = $(this),
              $this_panel = $("#" + $this.attr("aria-controls")),
              $accordion = $this.parent(),
              $accordion_multiselectable = $accordion.attr(
                "aria-multiselectable"
              ),
              $all_accordion_headers = $accordion.find(".js-accordion__header"),
              $all_accordion_panels = $accordion.find(".js-accordion__panel");

            $all_accordion_headers.attr("aria-selected", "false");
            $this.attr("aria-selected", "true");

            // opened or closed?
            if ($this.attr("aria-expanded") == "false") {
              // closed
              $this.attr("aria-expanded", "true");
              $this_panel.attr("aria-hidden", "false");
            } else {
              // opened
              $this.attr("aria-expanded", "false");
              $this_panel.attr("aria-hidden", "true");
            }

            if ($accordion_multiselectable == "false") {
              $all_accordion_panels
                .not($this_panel)
                .attr("aria-hidden", "true");
              $all_accordion_headers.not($this).attr("aria-expanded", "false");
            }

            setTimeout(function () {
              $this.focus();
            }, 0);
            event.preventDefault();
          })
          .on("keydown", ".js-accordion__header", function (event) {
            var $this = $(this),
              $accordion = $this.parent(),
              $all_accordion_headers = $accordion.find(".js-accordion__header"),
              $first_header = $accordion.find(".js-accordion__header").first(),
              $last_header = $accordion.find(".js-accordion__header").last(),
              $prev_header = $this.prevAll(".js-accordion__header").first(),
              $next_header = $this.nextAll(".js-accordion__header").first();

            // strike up or left in the tab => previous tab
            if (
              (event.keyCode == 37 || event.keyCode == 38) &&
              !event.ctrlKey
            ) {
              $all_accordion_headers.attr({
                tabindex: "-1",
                "aria-selected": "false",
              });
              // if we are on first one, activate last
              if ($this.is($first_header)) {
                $last_header
                  .attr("aria-selected", "true")
                  .removeAttr("tabindex");
                setTimeout(function () {
                  $last_header.focus();
                }, 0);
              }
              // else activate previous
              else {
                $prev_header
                  .attr("aria-selected", "true")
                  .removeAttr("tabindex");
                setTimeout(function () {
                  $prev_header.focus();
                }, 0);
              }
              event.preventDefault();
            }
            // strike down or right in the tab => next tab
            else if (
              (event.keyCode == 40 || event.keyCode == 39) &&
              !event.ctrlKey
            ) {
              $all_accordion_headers.attr({
                tabindex: "-1",
                "aria-selected": "false",
              });
              // if we are on last one, activate first
              if ($this.is($last_header)) {
                $first_header
                  .attr("aria-selected", "true")
                  .removeAttr("tabindex");
                setTimeout(function () {
                  $first_header.focus();
                }, 0);
              }
              // else activate next
              else {
                $next_header
                  .attr("aria-selected", "true")
                  .removeAttr("tabindex");
                setTimeout(function () {
                  $next_header.focus();
                }, 0);
              }
              event.preventDefault();
            }
            // strike home in the tab => 1st tab
            else if (event.keyCode == 36) {
              $all_accordion_headers.attr({
                tabindex: "-1",
                "aria-selected": "false",
              });
              $first_header
                .attr("aria-selected", "true")
                .removeAttr("tabindex");
              setTimeout(function () {
                $first_header.focus();
              }, 0);
              event.preventDefault();
            }
            // strike end in the tab => last tab
            else if (event.keyCode == 35) {
              $all_accordion_headers.attr({
                tabindex: "-1",
                "aria-selected": "false",
              });
              $last_header.attr("aria-selected", "true").removeAttr("tabindex");
              setTimeout(function () {
                $last_header.focus();
              }, 0);
              event.preventDefault();
            }
          })
          .on("keydown", ".js-accordion__panel", function (event) {
            var $this = $(this),
              $this_header = $("#" + $this.attr("aria-labelledby")),
              $accordion = $this.parent(),
              $first_header = $accordion.find(".js-accordion__header").first(),
              $prev_header = $this_header
                .prevAll(".js-accordion__header")
                .first(),
              $next_header = $this_header
                .nextAll(".js-accordion__header")
                .first(),
              $last_header = $accordion.find(".js-accordion__header").last();

            // strike up + ctrl => go to header
            if (event.keyCode == 38 && event.ctrlKey) {
              setTimeout(function () {
                $this_header.focus();
              }, 0);
              event.preventDefault();
            }
            // strike pageup + ctrl => go to prev header
            else if (event.keyCode == 33 && event.ctrlKey) {
              if ($this_header.is($first_header)) {
                setTimeout(function () {
                  $last_header.focus();
                }, 0);
                event.preventDefault();
              } else {
                setTimeout(function () {
                  $prev_header.focus();
                }, 0);
                event.preventDefault();
              }
            }
            // strike pagedown + ctrl => go to next header
            else if (event.keyCode == 34 && event.ctrlKey) {
              if ($this_header.is($last_header)) {
                setTimeout(function () {
                  $first_header.focus();
                }, 0);
                event.preventDefault();
              } else {
                setTimeout(function () {
                  $next_header.focus();
                }, 0);
                event.preventDefault();
              }
            }
          });
        (function () {
          var tablist = document.querySelectorAll('[role="tablist"]')[0];
          //window tabs;
          var panels;

          generateArrays();

          function generateArrays() {
            window.tabs = document.querySelectorAll('[role="tab"]');
            panels = document.querySelectorAll('[role="tabpanel"]');
          }

          // For easy reference
          var keys = {
            end: 35,
            home: 36,
            left: 37,
            up: 38,
            right: 39,
            down: 40,
            delete: 46,
            enter: 13,
            space: 32,
          };

          // Add or substract depenign on key pressed
          var direction = {
            37: -1,
            38: -1,
            39: 1,
            40: 1,
          };

          // Bind listeners
          for (i = 0; i < tabs.length; ++i) {
            addListeners(i);
          }

          function addListeners(index) {
            tabs[index].addEventListener("click", clickEventListener);
            tabs[index].addEventListener("keydown", keydownEventListener);
            tabs[index].addEventListener("keyup", keyupEventListener);

            // Build an array with all tabs (<button>s) in it
            tabs[index].index = index;
          }

          // When a tab is clicked, activateTab is fired to activate it
          function clickEventListener(event) {
            var tab = event.target;
            activateTab(tab, false);

            if (tab.id === "complex") {
              $("#tabFrame").attr(
                "src",
                "https://public.tableau.com/views/CTSchoolDistrictsbyIncomeandGradeLevels2009-13/Sheet1?:showVizHome=no&:embed=true"
              );
            } else if (tab.id === "agnes") {
              $("#tabFrame").attr(
                "src",
                "https://public.tableau.com/views/CTSchoolDistrictsbyIncomeandGradeLevels2009-13/Sheet1?:showVizHome=no&:embed=true"
              );
            } else if (tab.id === "joke") {
              $("#tabFrame").attr(
                "src",
                "https://public.tableau.com/views/CTSchoolDistrictsbyIncomeandGradeLevels2009-13/Sheet1?:showVizHome=no&:embed=true"
              );
            }
          }

          // Handle keydown on tabs
          function keydownEventListener(event) {
            var key = event.keyCode;

            switch (key) {
              case keys.end:
                event.preventDefault();
                // Activate last tab
                focusLastTab();
                break;
              case keys.home:
                event.preventDefault();
                // Activate first tab
                focusFirstTab();
                break;

              // Up and down are in keydown
              // because we need to prevent page scroll >:)
              case keys.up:
              case keys.space:
                event.preventDefault();
              case keys.down:
                determineOrientation(event);
                break;
            }
          }

          // Handle keyup on tabs
          function keyupEventListener(event) {
            var key = event.keyCode;
            var tab = event.target;

            switch (key) {
              case keys.left:
              case keys.right:
                determineOrientation(event);
                break;
              case keys.delete:
                determineDeletable(event);
                break;
              case keys.enter:
                event.preventDefault();
                activateTab(event.target);
                if (tab.id === "complex") {
                  $("#tabFrame").attr(
                    "src",
                    "https://public.tableau.com/views/CTSchoolDistrictsbyIncomeandGradeLevels2009-13/Sheet1?:showVizHome=no&:embed=true"
                  );
                } else if (tab.id === "agnes") {
                  $("#tabFrame").attr(
                    "src",
                    "https://public.tableau.com/views/CTSchoolDistrictsbyIncomeandGradeLevels2009-13/Sheet1?:showVizHome=no&:embed=true"
                  );
                } else if (tab.id === "joke") {
                  $("#tabFrame").attr(
                    "src",
                    "https://public.tableau.com/views/CTSchoolDistrictsbyIncomeandGradeLevels2009-13/Sheet1?:showVizHome=no&:embed=true"
                  );
                }
                break;

              case keys.space:
                event.preventDefault();
                activateTab(event.target);
                if (tab.id === "complex") {
                  $("#tabFrame").attr(
                    "src",
                    "https://public.tableau.com/views/CTSchoolDistrictsbyIncomeandGradeLevels2009-13/Sheet1?:showVizHome=no&:embed=true"
                  );
                } else if (tab.id === "agnes") {
                  $("#tabFrame").attr(
                    "src",
                    "https://public.tableau.com/views/CTSchoolDistrictsbyIncomeandGradeLevels2009-13/Sheet1?:showVizHome=no&:embed=true"
                  );
                } else if (tab.id === "joke") {
                  $("#tabFrame").attr(
                    "src",
                    "https://public.tableau.com/views/CTSchoolDistrictsbyIncomeandGradeLevels2009-13/Sheet1?:showVizHome=no&:embed=true"
                  );
                }
                break;
            }
          }

          // When a tablistâ€™s aria-orientation is set to vertical,
          // only up and down arrow should function.
          // In all other cases only left and right arrow function.
          function determineOrientation(event) {
            var key = event.keyCode;
            var vertical =
              tablist.getAttribute("aria-orientation") == "vertical";
            var proceed = false;

            if (vertical) {
              if (key === keys.up || key === keys.down) {
                event.preventDefault();
                proceed = true;
              }
            } else {
              if (key === keys.left || key === keys.right) {
                proceed = true;
              }
            }

            if (proceed) {
              switchTabOnArrowPress(event);
            }
          }

          // Either focus the next, previous, first, or last tab
          // depening on key pressed
          function switchTabOnArrowPress(event) {
            var pressed = event.keyCode;

            if (direction[pressed]) {
              var target = event.target;
              if (target.index !== undefined) {
                if (tabs[target.index + direction[pressed]]) {
                  tabs[target.index + direction[pressed]].focus();
                } else if (pressed === keys.left || pressed === keys.up) {
                  focusLastTab();
                } else if (pressed === keys.right || pressed == keys.down) {
                  focusFirstTab();
                }
              }
            }
          }

          // Activates any given tab panel
          window.activateTab = function (tab, setFocus) {
            setFocus = setFocus || true;
            // Deactivate all other tabs

            if (tab.id == "pov" || tab.id == "race") deactivateTabs();

            // Remove tabindex attribute
            tab.removeAttribute("tabindex");

            // Set the tab as selected
            tab.setAttribute("aria-selected", "true");

            // Get the value of aria-controls (which is an ID)
            var controls = tab.getAttribute("aria-controls");

            // Remove hidden attribute from tab panel to make it visible
            document.getElementById(controls).removeAttribute("hidden");

            // Set focus when required
            if (setFocus) {
              tab.focus();
            }
          };

          $("form").each(function () {
            this.reset();
          });
/*           window.cty3aSelected = function (selection) {
            if (selection != "") {
              ch3aShowCharts();
              $("#selLeg3a").val("").trigger("change");
              $("#selDist3a").val("").trigger("change");
              $("#ch3aHead").html(selection + " County");
              vizzes["ch3aViz"].revertAllAsync();
              worksheetArray = vizzes["ch3aViz"]
                .getWorkbook()
                .getActiveSheet()
                .getWorksheets();

              for (var i = 0; i < worksheetArray.length; i++) {
                worksheetArray[i].applyFilterAsync(
                  "Rpt County Name",
                  selection,
                  tableau.FilterUpdateType.REPLACE
                );
              }
              setTimeout(function () {
                getVizData("ch3a", "ch3aViz");
              }, 3000);
              setTimeout(function () {
                $("#selCty3a").focus();
              }, 2000);
            }
            gtag("event", "View", {
              event_category: "Report",
              event_label: "ch3aCountyFilter",
            });
          };

          window.dist3aSelected = function (selection) {
            if (selection != "") {
              ch3aShowCharts();
              $("#selCty3a").val("").trigger("change");
              $("#selLeg3a").val("").trigger("change");
              $("#ch3aHead").html(selection);
              vizzes["ch3aViz"].revertAllAsync();
              worksheetArray = vizzes["ch3aViz"]
                .getWorkbook()
                .getActiveSheet()
                .getWorksheets();

              for (var i = 0; i < worksheetArray.length; i++) {
                worksheetArray[i].applyFilterAsync(
                  "District Name",
                  selection,
                  tableau.FilterUpdateType.REPLACE
                );
              }
              setTimeout(function () {
                getVizData("ch3a", "ch3aViz");
              }, 3000);
              setTimeout(function () {
                $("#selDist3a").focus();
              }, 2000);
            }
            gtag("event", "View", {
              event_category: "Report",
              event_label: "ch3aDistFilter",
            });
          };

          window.leg3aSelected = function (selection) {
            if (selection != "") {
              ch3aShowCharts();
              $("#selDist3a").val("").trigger("change");
              $("#selCty3a").val("").trigger("change");
              $("#ch3aHead").html("Legislative District " + selection);
              vizzes["ch3aViz"].revertAllAsync();
              worksheetArray = vizzes["ch3aViz"]
                .getWorkbook()
                .getActiveSheet()
                .getWorksheets();

              for (var i = 0; i < worksheetArray.length; i++) {
                worksheetArray[i].applyFilterAsync(
                  "Legislative District",
                  selection,
                  tableau.FilterUpdateType.REPLACE
                );
              }
              setTimeout(function () {
                getVizData("ch3a", "ch3aViz");
              }, 3000);
              setTimeout(function () {
                $("#selLeg3a").focus();
              }, 2000);
            }
            gtag("event", "View", {
              event_category: "Report",
              event_label: "ch3aLegFilter",
            });
          };

          window.state3aSelected = function () {
            ch3aShowCharts();
            $("#selDist3a").val("").trigger("change");
            $("#selCty3a").val("").trigger("change");
            $("#selLeg3a").val("").trigger("change");
            $("#ch3aHead").html("Statewide");
            vizzes["ch3aViz"].revertAllAsync();
            getVizData("ch3a", "ch3aViz");
            setTimeout(function () {
              $("#ch3aButton").focus();
            }, 2000);
            gtag("event", "View", {
              event_category: "Report",
              event_label: "ch3aStatewide",
            });
          };

          window.cty3bSelected = function (selection) {
            if (selection != "") {
              ch3bShowCharts();
              $("#selLeg3b").val("").trigger("change");
              $("#selDist3b").val("").trigger("change");
              $("#ch3bHead").html(selection + " County");
              vizzes["ch3bViz"].revertAllAsync();
              worksheetArray = vizzes["ch3bViz"]
                .getWorkbook()
                .getActiveSheet()
                .getWorksheets();
              for (var i = 0; i < worksheetArray.length; i++) {
                worksheetArray[i].applyFilterAsync(
                  "Rpt County Name",
                  selection,
                  tableau.FilterUpdateType.REPLACE
                );
              }
              setTimeout(function () {
                getVizData("ch3b", "ch3bViz");
              }, 3000);
              setTimeout(function () {
                $("#selCty3b").focus();
              }, 2000);
            }
            gtag("event", "View", {
              event_category: "Report",
              event_label: "ch3bCountyFilter",
            });
          };

          window.dist3bSelected = function (selection) {
            if (selection != "") {
              ch3bShowCharts();
              $("#selCty3b").val("").trigger("change");
              $("#selLeg3b").val("").trigger("change");
              $("#ch3bHead").html(selection);
              vizzes["ch3bViz"].revertAllAsync();
              worksheetArray = vizzes["ch3bViz"]
                .getWorkbook()
                .getActiveSheet()
                .getWorksheets();
              for (var i = 0; i < worksheetArray.length; i++) {
                worksheetArray[i].applyFilterAsync(
                  "District Name",
                  selection,
                  tableau.FilterUpdateType.REPLACE
                );
              }
              setTimeout(function () {
                getVizData("ch3b", "ch3bViz");
              }, 3000);
              setTimeout(function () {
                $("#selDist3b").focus();
              }, 2000);
            }
            gtag("event", "View", {
              event_category: "Report",
              event_label: "ch3bDistrictFilter",
            });
          };

          window.leg3bSelected = function (selection) {
            if (selection != "") {
              ch3bShowCharts();
              $("#selDist3b").val("").trigger("change");
              $("#selCty3b").val("").trigger("change");
              $("#ch3bHead").html("Legislative District " + selection);
              vizzes["ch3bViz"].revertAllAsync();
              worksheetArray = vizzes["ch3bViz"]
                .getWorkbook()
                .getActiveSheet()
                .getWorksheets();
              for (var i = 0; i < worksheetArray.length; i++) {
                worksheetArray[i].applyFilterAsync(
                  "Legislative District",
                  selection,
                  tableau.FilterUpdateType.REPLACE
                );
              }
              setTimeout(function () {
                getVizData("ch3b", "ch3bViz");
              }, 3000);
              setTimeout(function () {
                $("#selLeg3b").focus();
              }, 2000);
            }
            gtag("event", "View", {
              event_category: "Report",
              event_label: "ch3bLegFilter",
            });
          };

          window.state3bSelected = function () {
            ch3bShowCharts();
            $("#selDist3b").val("").trigger("change");
            $("#selCty3b").val("").trigger("change");
            $("#selLeg3b").val("").trigger("change");
            $("#ch3bHead").html("Statewide");
            vizzes["ch3bViz"].revertAllAsync();
            getVizData("ch3b", "ch3bViz");
            setTimeout(function () {
              $("#ch3bButton").focus();
            }, 2000);
            gtag("event", "View", {
              event_category: "Report",
              event_label: "ch3bStatewide",
            });
          };
          window.cty4selected = function (selection) {
            if (selection != "") {
              ch4aShowCharts("ch4aChButton");
              $("#selLeg4a").val("").trigger("change");
              $("#selDist4a").val("").trigger("change");
              $("#ch4head").html(selection + " County");
              vizzes["ch4aViz"].revertAllAsync();
              worksheetArray = vizzes["ch4aViz"]
                .getWorkbook()
                .getActiveSheet()
                .getWorksheets();
              worksheetArray[0]
                .applyFilterAsync(
                  "Rpt County Name",
                  selection,
                  tableau.FilterUpdateType.REPLACE
                )
                .then(
                  function () {
                    getVizData("ch4a", "ch4aViz");
                  },
                  function (err) {
                    console.log(err);
                  }
                );
              setTimeout(function () {
                $("#selCty4a").focus();
              }, 2000);
            }
            gtag("event", "View", {
              event_category: "Report",
              event_label: "ch4CountyFilter",
            });
          };

          window.dist4selected = function (selection) {
            if (selection != "") {
              ch4aShowCharts("ch4aChButton");
              $("#selCty4a").val("").trigger("change");
              $("#selLeg4a").val("").trigger("change");
              $("#ch4head").html(selection);
              vizzes["ch4aViz"].revertAllAsync();
              console.log(selection);
              worksheetArray = vizzes["ch4aViz"]
                .getWorkbook()
                .getActiveSheet()
                .getWorksheets();
              console.log(worksheetArray);
              worksheetArray[0]
                .applyFilterAsync(
                  "District Name",
                  selection,
                  tableau.FilterUpdateType.REPLACE
                )
                .then(
                  function () {
                    console.log("getVizData");
                    getVizData("ch4a", "ch4aViz");
                  },
                  function (err) {
                    console.log(err);
                  }
                );
              console.log(worksheetArray);
              setTimeout(function () {
                $("#selDist4a").focus();
              }, 2000);
            }
            gtag("event", "View", {
              event_category: "Report",
              event_label: "ch4DistrictFilter",
            });
          };

          window.leg4selected = function (selection) {
            if (selection != "") {
              ch4aShowCharts("ch4aChButton");
              $("#selDist4a").val("").trigger("change");
              $("#selCty4a").val("").trigger("change");
              $("#ch4head").html("Legislative District " + selection);
              vizzes["ch4aViz"].revertAllAsync();
              worksheetArray = vizzes["ch4aViz"]
                .getWorkbook()
                .getActiveSheet()
                .getWorksheets();
              for (var i = 0; i < worksheetArray.length; i++) {
                worksheetArray[i].applyFilterAsync(
                  "Legislative District",
                  selection,
                  tableau.FilterUpdateType.REPLACE
                );
              }
              setTimeout(function () {
                getVizData("ch4a", "ch4aViz");
                $("#selLeg4a").focus();
              }, 3000);
            }
            gtag("event", "View", {
              event_category: "Report",
              event_label: "ch4LegFilter",
            });
          };
          window.state4selected = function () {
            ch4aShowCharts("ch4aChButton");
            $("#selDist4a").val("").trigger("change");
            $("#selCty4a").val("").trigger("change");
            $("#selLeg4a").val("").trigger("change");
            $("#ch4head").html("Statewide");
            vizzes["ch4aViz"].revertAllAsync();
            getVizData("ch4a", "ch4aViz");
            setTimeout(function () {
              $("#ch4aButton").focus();
            }, 2000);
            gtag("event", "View", {
              event_category: "Report",
              event_label: "ch4Statewide",
            });
          };
          window.cty5aSelected = function (selection) {
            if (selection != "") {
              ch5aShowCharts();
              $("#selLeg5a").val("").trigger("change");
              $("#selDist5a").val("").trigger("change");
              $("#ch5aHead").html(selection + " County");
              vizzes["ch5aViz"].revertAllAsync();
              worksheetArray = vizzes["ch5aViz"]
                .getWorkbook()
                .getActiveSheet()
                .getWorksheets();

              worksheetArray[0]
                .applyFilterAsync(
                  "Rpt County Name",
                  selection,
                  tableau.FilterUpdateType.REPLACE
                )
                .then(function () {
                  getVizData("ch5a", "ch5aViz");
                });
              setTimeout(function () {
                $("#selCty5a").focus();
              }, 2000);
            }
          };

          window.dist5aSelected = function (selection) {
            if (selection != "") {
              ch5aShowCharts();
              $("#selCty5a").val("").trigger("change");
              $("#selLeg5a").val("").trigger("change");
              $("#ch5aHead").html(selection);
              vizzes["ch5aViz"].revertAllAsync();
              worksheetArray = vizzes["ch5aViz"]
                .getWorkbook()
                .getActiveSheet()
                .getWorksheets();

              worksheetArray[0]
                .applyFilterAsync(
                  "District Name",
                  selection,
                  tableau.FilterUpdateType.REPLACE
                )
                .then(function () {
                  getVizData("ch5a", "ch5aViz");
                });
              setTimeout(function () {
                $("#selDist5a").focus();
              }, 2000);
            }
            gtag("event", "View", {
              event_category: "Report",
              event_label: "ch5CountyFilter",
            });
          };

          window.leg5aSelected = function (selection) {
            if (selection != "") {
              ch5aShowCharts();
              $("#selDist5a").val("").trigger("change");
              $("#selCty5a").val("").trigger("change");
              $("#ch5aHead").html("Legislative District " + selection);
              vizzes["ch5aViz"].revertAllAsync();
              worksheetArray = vizzes["ch5aViz"]
                .getWorkbook()
                .getActiveSheet()
                .getWorksheets();

              worksheetArray[0]
                .applyFilterAsync(
                  "Legislative District",
                  selection,
                  tableau.FilterUpdateType.REPLACE
                )
                .then(function () {
                  getVizData("ch5a", "ch5aViz");
                });
              setTimeout(function () {
                $("#selLeg5a").focus();
              }, 2000);
            }
            gtag("event", "View", {
              event_category: "Report",
              event_label: "ch5DistrictFilter",
            });
          };

          window.state5aSelected = function () {
            ch5aShowCharts();
            $("#selDist5a").val("").trigger("change");
            $("#selCty5a").val("").trigger("change");
            $("#selLeg5a").val("").trigger("change");
            $("#ch5aHead").html("Statewide");
            vizzes["ch5aViz"].revertAllAsync();
            getVizData("ch5a", "ch5aViz");
            setTimeout(function () {
              $("#ch5aButton").focus();
            }, 2000);
            gtag("event", "View", {
              event_category: "Report",
              event_label: "ch5Statewide",
            });
          }; */

          // Deactivate all tabs and tab panels
          function deactivateTabs() {
            for (t = 0; t < tabs.length; t++) {
              tabs[t].setAttribute("tabindex", "-1");
              tabs[t].setAttribute("aria-selected", "false");
            }

            for (p = 0; p < panels.length; p++) {
              panels[p].setAttribute("hidden", "hidden");
            }
          }

          // Make a guess
          function focusFirstTab() {
            tabs[0].focus();
          }

          // Make a guess
          function focusLastTab() {
            tabs[tabs.length - 1].focus();
          }

          // Detect if a tab is deletable
          function determineDeletable(event) {
            target = event.target;

            if (target.getAttribute("data-deletable") !== null) {
              // Delete target tab
              deleteTab(event, target);

              // Update arrays related to tabs widget
              generateArrays();

              // Activate the closest tab to the one that was just deleted
              if (target.index - 1 < 0) {
                activateTab(tabs[0]);
              } else {
                activateTab(tabs[target.index - 1]);
              }
            }
          }

          // Determine whether there should be a delay
          // when user navigates with the arrow keys
          function determineDelay() {
            var hasDelay = tablist.hasAttribute("data-delay");
            var delay = 0;

            if (hasDelay) {
              var delayValue = tablist.getAttribute("data-delay");
              if (delayValue) {
                delay = delayValue;
              } else {
                // If no value is specified, default to 300ms
                delay = 300;
              }
            }

            return delay;
          }
        })();

        var oldOrg;
        var track = 0;

        $(".filter").waitUntilExists(function () {
          if (this.id == "box_ECO_DEV_REGION") {
            if (this.value !== "&nbsp;" && this.value !== "FOC_NONE") {
              var that3 = this;
              setTimeout(function () {
                that3.parentElement.parentElement.parentElement.parentElement.parentElement.parentElement.parentElement.parentElement.parentElement.parentElement.parentElement.children[1].children[1].children[0].innerHTML =
                  '<span class="title msg_boxTitle">' +
                  that3.previousSibling.innerHTML +
                  '</span> <span class="parent"></span>';
              }, 1700);
              this.parentElement.parentElement.parentElement.parentElement.parentElement.parentElement[1].value =
                "";
            }
          }

          $(".filter").change(function (that5) {
            if (this.id == "box_ECO_DEV_REGION") {
              var this2 =
                this.parentElement.parentElement.parentElement.parentElement
                  .parentElement.parentElement.parentElement.parentElement
                  .parentElement.parentElement.parentElement;
              //  console.log(this2);
              if (track++ < 1)
                oldOrg = this2.children[1].children[1].children[0].innerHTML;
          /*     console.log(
                this2.children[2].children[0].children[0].children[0]
                  .children[1][4].previousSibling.innerHTML
              ); */
              this2.children[1].children[1].children[0].innerHTML =
                this2.children[2].children[0].children[0].children[0].children[1][4].previousSibling.innerHTML;

              this2.children[2].children[0].children[0].children[0].children[1][1].value =
                "";

              if (this.value !== "FOC_NONE") {
                var that = this;
                setTimeout(function () {
                  that.parentElement.parentElement.parentElement.parentElement.parentElement.parentElement.parentElement.parentElement.parentElement.parentElement.parentElement.children[1].children[1].children[0].innerHTML =
                    '<span class="title msg_boxTitle">' +
                    that.previousSibling.innerHTML +
                    '</span> <span class="parent"></span>';
                }, 1000);
                this.parentElement.parentElement.parentElement.parentElement.parentElement.parentElement[1].value =
                  "";
              } else {
                this2.children[1].children[1].children[0].innerHTML = oldOrg;
                track = 0;
              }
            }
          });
        });

        /*         var Chart;
                //https://eclds.mn.gov/ibi_apps/WFServlet?IBIAPP_app=ECLDSwebsvc&IBIF_ex=ecldsws_getdata_sec_f_birthoutcomes.fex&orgId=007501&FISCAL_YEAR=2022  
        
                Chart = new Highcharts.Chart({
                  chart: {
                    renderTo: "container",
                    type: "bar",
                  },
                  legend: { enabled: false },
                  exporting: {
                    buttons: {
                      contextButton: {
                        enabled: false,
                      },
                    },
                  },
                  title: {
                    text: "Federal Race Definition",
                  },
                  credits: {
                    enabled: false,
                  },
                  xAxis: {
                    categories: [
                      "American Indian / Alaska Native",
                      "Asian",
                      "Black/African American",
                      "Hispanic / Latino of any race",
                      "Native Hawaiian / Other Pacific Islander",
                      "White",
                      "Two or More Races",
                    ],
                  },
                  yAxis: {
                    title: {
                      text: "",
                    },
                    min: 0,
                  },
                  plotOptions: {
                    series: {
                      lineWidth: 2,
                      color: "#003865",
                    },
                    bar: {
                      dataLabels: {
                        enabled: true,
                        format: "<b>{y}</b>%",
                      },
                    },
                  },
                  series: [
                    {
                      name: "Percent",
                      data: [2.0, 7.0, 17.0, 10.1, 0, 57, 7],
                    },
                  ],
                }); */
        //Send page view to google analytics

        if (hash.indexOf("#/") > -1) {
          var storyChp = hash.substring(2);
        //  console.log("REPORT:", storyChp);
          gtag("event", "View", {
            event_category: "Report",
            event_label: storyChp,
          });
        } else {
       //   console.log("REPORT:", repName);
          gtag("event", "View", {
            event_category: "Report",
            event_label: repName,
          });
        }

        (function () {
          var parse = JSON.parse;
          JSON = {
            stringify: JSON.stringify,
            validate: function (str) {
              try {
                parse(str);
                return true;
              } catch (err) {
                return err;
              }
            },
            parse: function (str) {
              try {
                return parse(str);
              } catch (err) {
                return undefined;
              }
            },
          };
        })();

        $(".filterDef").each(function () {
          if (hash.indexOf("birthOutcomes") > -1)
            $(this).attr("href", "https://education.mn.gov/MDE/data/mde089481");
          else if (hash.indexOf("childProtectionInvolvement") > -1)
            $(this).attr("href", "https://education.mn.gov/MDE/data/mde089485");
          else if (hash.indexOf("programParticipation") > -1)
            $(this).attr("href", "https://education.mn.gov/MDE/data/mde089475");
          else if (hash.indexOf("kgAttend") > -1)
            $(this).attr(
              "href",
              "https://education.mn.gov/MDE/data/PROD045946"
            );
          else if (hash.indexOf("earlyChildhoodScreening") > -1)
            $(this).attr(
              "href",
              "https://education.mn.gov/MDE/data/PROD045947"
            );
          else if (hash.indexOf("childDemographics") > -1)
            $(this).attr("href", "https://education.mn.gov/MDE/data/mde089476");
          else if (hash.indexOf("familyDemographics") > -1)
            $(this).attr("href", "https://education.mn.gov/MDE/data/mde089477");
          else if (hash.indexOf("economicFoodAssistance") > -1)
            $(this).attr("href", "https://education.mn.gov/MDE/data/mde089478");
          else if (hash.indexOf("summaryReport") > -1)
            $(this).attr("href", "https://education.mn.gov/MDE/data/mde089479");
          else if (hash.indexOf("thirdGradeEdStatus") > -1)
            $(this).attr("href", "https://education.mn.gov/MDE/data/mde089480");
          else if (hash.indexOf("maternalTraitsAttendance") > -1)
            $(this).attr("href", "https://education.mn.gov/MDE/data/mde089482");
          else if (hash.indexOf("maternalTraitsProficiency") > -1)
            $(this).attr("href", "https://education.mn.gov/MDE/data/mde089483");
          else if (hash.indexOf("ECSEto3rdGrade") > -1)
            $(this).attr("href", "https://education.mn.gov/MDE/data/mde089484");
          else if (hash.indexOf("deafHardOfHearing") > -1)
            $(this).attr("href", "https://education.mn.gov/MDE/data/mde089486");
          else if (hash.indexOf("scholarships") > -1)
            $(this).attr("href", "https://education.mn.gov/MDE/data/mde089487");
          else if (hash.indexOf("parentAware") > -1)
            $(this).attr("href", "https://education.mn.gov/MDE/data/mde089488");
          /*        if (hash.indexOf("KEPBirthOutcomes") > -1)
                                   $(this).attr("href", "https://education.mn.gov/MDE/data/mde089476"); */
        });

        if (
          hash.indexOf("KEPBirthOutcomes") > -1 ||
          hash.indexOf("deafHardOfHearing") > -1
        ) {
          $(".orgRow").hide();
        } else {
          $(".orgRow").show();
          $(
            "<div class='or' style='padding-left:25%'><strong>or</strong></div>"
          ).insertBefore(".filters");
          $("<div class='hr'><hr/></div>").insertAfter(".filters");
        }

        if (
          hash.indexOf("parentAware") > -1 ||
          hash.indexOf("scholarships") > -1
        ) {
          if (hash.indexOf("parentAware") > -1) {
            setTimeout(function () {
              $(".tt-dataset-schools").css("display", "none");
              $(".orgFinderLabel").html(
                "<span class='main'>School County</span><span class='screenReadersOnly'>Key down for more options after starting to type. </span>"
              );
            }, 1500);
          } else {
            setTimeout(function () {
              $(".orgFinderLabel").html(
                "<span class='main'>School County</span><span class='note'>(Or School District)</span> <span class='screenReadersOnly'>Key down for more options after starting to type. </span>"
              );
            }, 1500);
          }
        } else {
          setTimeout(function () {
            $(".tt-dataset-schools").css("display", "inline");
            $(".orgFinderLabel").html(
              "<span class='main'>School County</span><span class='note'>(Or School District)</span> <span class='screenReadersOnly'>Key down for more options after starting to type. </span>"
            );
          }, 1500);
        }

        if (
          hash.indexOf("birthOutcomes") > -1 ||
          hash.indexOf("maternalTraitsProficiency") > -1 ||
          hash.indexOf("ECSEto3rdGrade") > -1
        ) {
          setTimeout(function () {
            $.each(charts, function (index, value) {
              if (this.userOptions.lineData != null && this.done != true) {
                var dataPt = Number($("#stateData")[0].textContent);
                this.addSeries(
                  {
                    name: "Statewide",
                    type: "spline",
                    data: [
                      {
                        x: -0.4,
                        y: dataPt,
                      },
                      dataPt,
                      {
                        x: this.userOptions.lineSpan,
                        y: dataPt,
                      },
                    ],
                    tooltip: {
                      valueSuffix: "%",
                    },
                    color: "#8d3f2b",
                    lineWidth: 2,
                    marker: {
                      lineWidth: 2,
                      enabled: false,
                    },
                  },
                  false
                );
                this.xAxis[0].setExtremes(0.1, this.userOptions.lineSpan - 0.4);
                this.done = true;
              }
            });
          }, 6000);
        }

        if (hash.indexOf("summaryReport") > -1) {
          var n = (hash.match(/orgId/g) || []).length;
          // We only want one pane on the summary report, if we are coming from a page we had more than one open, default to statewide with 1 pane
          if (n > 1) {
            location.hash =
              "#summaryReport/orgId--999999000__groupType--state__FISCAL_YEAR--2022__p--1";
            setTimeout(function () {
              Backbone.trigger("reportSet");
            }, 100);
          }
          $(".dataBox").css("width", "96%");
          $(".controls").css("display", "none");
          $(".dataBox").css("max-width", "1000px");
          wideBox = true;

          //Export to Spreadsheet

          $("#AllOrgKindergartners").waitUntilExists(function () {
            $("#AllOrgKindergartners").tableExport({
              headings: true, // (Boolean), display table headings (th elements) in the first row
              formats: ["xlsx"], // (String[]), filetypes for the export
              fileName: "AllOrgKindergartners", // (id, String), filename for the downloaded file
              bootstrap: true, // (Boolean), style buttons using bootstrap
              position: "top", // (top, bottom), position of the caption element relative to table
            });
            $("#ChildCareAssistanceProgram").tableExport({
              headings: true, // (Boolean), display table headings (th elements) in the first row
              formats: ["xlsx"], // (String[]), filetypes for the export
              fileName: "ChildCareAssistanceProgram", // (id, String), filename for the downloaded file
              bootstrap: true, // (Boolean), style buttons using bootstrap
              position: "top", // (top, bottom), position of the caption element relative to table
            });
            $("#EarlyChildhoodFamilyEducation").tableExport({
              headings: true, // (Boolean), display table headings (th elements) in the first row
              formats: ["xlsx"], // (String[]), filetypes for the export
              fileName: "EarlyChildhoodFamilyEducation", // (id, String), filename for the downloaded file
              bootstrap: true, // (Boolean), style buttons using bootstrap
              position: "top", // (top, bottom), position of the caption element relative to table
            });
            $("#EarlyChildhoodSpecialEducation").tableExport({
              headings: true, // (Boolean), display table headings (th elements) in the first row
              formats: ["xlsx"], // (String[]), filetypes for the export
              fileName: "EarlyChildhoodSpecialEducation", // (id, String), filename for the downloaded file
              bootstrap: true, // (Boolean), style buttons using bootstrap
              position: "top", // (top, bottom), position of the caption element relative to table
            });
            $("#MnDistrictPreSchool").tableExport({
              headings: true, // (Boolean), display table headings (th elements) in the first row
              formats: ["xlsx"], // (String[]), filetypes for the export
              fileName: "MnDistrictPreSchool", // (id, String), filename for the downloaded file
              bootstrap: true, // (Boolean), style buttons using bootstrap
              position: "top", // (top, bottom), position of the caption element relative to table
            });
          });
        } else if (hash.indexOf("/ds3") > -1) {
          $("#tabFrame").attr(
            "src",
            "https://public.tableau.com/views/CTSchoolDistrictsbyIncomeandGradeLevels2009-13/Sheet1?:showVizHome=no&:embed=true"
          );
        } else {
          $(".dataBox").css("width", "");
          $(".controls").css("display", "");
          $(".dataBox").css("max-width", "");
        }

        var repName = location.hash.substring(0, location.hash.indexOf("/"));
        if (repName.length < 1) repName = hash.substring(0, 10);

        //Send page view to google analytics
        //   gtag('event', 'View', { 'event_category' : 'Report', 'event_label' :  repName);

        $(window).hashchange(function () {

          //  changeFunc();
          var hash = location.hash;
       /*    if (hash.indexOf("ch3") > -1) {
            if (vizzes.ch3aViz) {
              // If a viz object exists, delete it.
              vizzes.ch3aViz.dispose();
            }
            initViz(ch3aURL, "ch3a", ch3aVizDiv, "ch3aViz"); 
          } else if (hash.indexOf("ch4") > -1) {
            console.log(vizzes);
            if (vizzes.ch5aViz) {
              // If a viz object exists, delete it.
              vizzes.ch5aViz.dispose();
              console.log("DISPOSE ch5");
            }
            initViz(ch5aURL, "ch5a", ch5aVizDiv, "ch5aViz");
          } */

          /*  $("#ch5placeholder").html("<div id='ch5a' class='viz'></div>");
                        initViz(ch5aURL, "ch5a", ch5aVizDiv, "ch5aViz"); */

          var reportName = hash.substring(0, hash.indexOf("/"));
          if (reportName.length < 1) reportName = hash.substring(0, 10);

          if (hash.indexOf("#/") > -1) {
            var storyChp = hash.substring(2);
            console.log("REPORT:", storyChp);
            gtag("event", "View", {
              event_category: "Report",
              event_label: storyChp,
            });
          } else {
            console.log("REPORT:", reportName);
            gtag("event", "View", {
              event_category: "Report",
              event_label: reportName,
            });
          }
          // Slick image slider is not formatted correctly if home page not loaded first, going to next slide fixes issue
          if (hash.length < 2) {
            $(".slick-next").trigger("click");
          }
          //Send page view event to google analytics

          $(".filterDef").each(function () {
            if (hash.indexOf("birthOutcomes") > -1)
              $(this).attr(
                "href",
                "https://education.mn.gov/MDE/data/mde089481"
              );
            else if (hash.indexOf("childProtectionInvolvement") > -1)
              $(this).attr(
                "href",
                "https://education.mn.gov/MDE/data/mde089485"
              );
            else if (hash.indexOf("programParticipation") > -1)
              $(this).attr(
                "href",
                "https://education.mn.gov/MDE/data/mde089475"
              );
            else if (hash.indexOf("kgAttend") > -1)
              $(this).attr(
                "href",
                "https://education.mn.gov/MDE/data/PROD045946"
              );
            else if (hash.indexOf("earlyChildhoodScreening") > -1)
              $(this).attr(
                "href",
                "https://education.mn.gov/MDE/data/PROD045947"
              );
            else if (hash.indexOf("childDemographics") > -1)
              $(this).attr(
                "href",
                "https://education.mn.gov/MDE/data/mde089476"
              );
            else if (hash.indexOf("familyDemographics") > -1)
              $(this).attr(
                "href",
                "https://education.mn.gov/MDE/data/mde089477"
              );
            else if (hash.indexOf("economicFoodAssistance") > -1)
              $(this).attr(
                "href",
                "https://education.mn.gov/MDE/data/mde089478"
              );
            else if (hash.indexOf("summaryReport") > -1)
              $(this).attr(
                "href",
                "https://education.mn.gov/MDE/data/mde089479"
              );
            else if (hash.indexOf("thirdGradeEdStatus") > -1)
              $(this).attr(
                "href",
                "https://education.mn.gov/MDE/data/mde089480"
              );
            else if (hash.indexOf("maternalTraitsAttendance") > -1)
              $(this).attr(
                "href",
                "https://education.mn.gov/MDE/data/mde089482"
              );
            else if (hash.indexOf("maternalTraitsProficiency") > -1)
              $(this).attr(
                "href",
                "https://education.mn.gov/MDE/data/mde089483"
              );
            else if (hash.indexOf("ECSEto3rdGrade") > -1)
              $(this).attr(
                "href",
                "https://education.mn.gov/MDE/data/mde089484"
              );
            else if (hash.indexOf("deafHardOfHearing") > -1)
              $(this).attr(
                "href",
                "https://education.mn.gov/MDE/data/mde089486"
              );
            else if (hash.indexOf("scholarships") > -1)
              $(this).attr(
                "href",
                "https://education.mn.gov/MDE/data/mde089487"
              );
            else if (hash.indexOf("parentAware") > -1)
              $(this).attr(
                "href",
                "https://education.mn.gov/MDE/data/mde089488"
              );
            /*        if (hash.indexOf("KEPBirthOutcomes") > -1)
                                       $(this).attr("href", "https://education.mn.gov/MDE/data/mde089476"); */
          });
          $(".or").each(function (index) {
            this.outerHTML = "";
          });
          $(".hr").each(function (index) {
            this.outerHTML = "";
          });

          if (
            hash.indexOf("KEPBirthOutcomes") > -1 ||
            hash.indexOf("deafHardOfHearing") > -1
          ) {
            $(".orgRow").hide();
            if (
              hash.indexOf("KEPBirthOutcomes") > -1 &&
              hash.indexOf("999999000") < 1
            ) {
              location.hash =
                "#KEPBirthOutcomes/orgId--999999000__groupType--state__FISCAL_YEAR--2015__DISABILITY_TYPE--FOC_NONE__HOME_LANGUAGE--FOC_NONE__ECSE--a__ECIP_DOMAIN--i__p--1";
              setTimeout(function () {
                Backbone.trigger("reportSet");
              }, 100);
            }
            if (
              hash.indexOf("deafHardOfHearing") > -1 &&
              hash.indexOf("999999000") < 1
            ) {
              location.hash =
                "#deafHardOfHearing/orgId--999999000__groupType--state__FISCAL_YEAR--2016__SUBJECT--R__ECSE--a__p--1";
              setTimeout(function () {
                Backbone.trigger("reportSet");
              }, 100);
            }
          } else if (hash.indexOf("ds3") > -1) {
            $("#tabFrame").attr(
              "src",
              "https://public.tableau.com/views/CTSchoolDistrictsbyIncomeandGradeLevels2009-13/Sheet1?:showVizHome=no&:embed=true"
            );
          } else {
            $(".orgRow").show();
            $(
              "<div class='or' style='padding-left:25%'><strong>or</strong></div>"
            ).insertBefore(".filters");
            $("<div class='hr'><hr/></div>").insertAfter(".filters");
          }

          if (
            hash.indexOf("parentAware") > -1 ||
            hash.indexOf("scholarships") > -1
          ) {
            if (hash.indexOf("parentAware") > -1) {
              setTimeout(function () {
                $(".tt-dataset-schools").css("display", "none");
                $(".orgFinderLabel").html(
                  "<span class='main'>School County</span><span class='screenReadersOnly'>Key down for more options after starting to type. </span>"
                );
              }, 1500);
            } else {
              setTimeout(function () {
                $(".orgFinderLabel").html(
                  "<span class='main'>School County</span><span class='note'>(Or School District)</span> <span class='screenReadersOnly'>Key down for more options after starting to type. </span>"
                );
              }, 1500);
            }
          } else {
            setTimeout(function () {
              $(".tt-dataset-schools").css("display", "inline");
              $(".orgFinderLabel").html(
                "<span class='main'>School County</span><span class='note'>(Or School District)</span> <span class='screenReadersOnly'>Key down for more options after starting to type. </span>"
              );
            }, 1500);
          }

          if (location.hash.indexOf("videos1") > -1) {
            gtag("event", "View", {
              event_category: "Report",
              event_label: "vid1",
            });
            $("#video1").html(
              "<video class='video-js vjs-default-skin' controls preload='auto' width='640' height='360' poster='videos/PROD046005.jpg' data-setup='{}' style='width: 640px;  height: 360px;  border: 1px solid black; '> <source src='videos/PROD046005.mp4' type='video/mp4' /> <source src='videos/PROD046005.webm' type='video/webm' /> <track kind='captions' src='videos/PROD046005.vtt' srclang='en' label='English'> </track> </video>"
            );
            $("#video2").html("");
            $("#video3").html("");
            $("#video4").html("");
            $("#video5").html("");
            $("#video6").html("");
            $("#video7").html("");
            $("#video8").html("");
            $("#video9").html("");
            $("#video0").html("");
          } else if (location.hash.indexOf("videos2") > -1) {
            gtag("event", "View", {
              event_category: "Report",
              event_label: "vid2",
            });
            $("#video2").html(
              "<video class='video-js vjs-default-skin' controls preload='auto' width='640' height='360' poster='videos/OHE_Navigating_ECLDS_Tutorial_September.jpg' data-setup='{}' style='width: 640px; height: 360px;  border: 1px solid black; '> <source src='videos/OHE_Navigating_ECLDS_Tutorial_September.mp4' type='video/mp4' /> <source src='videos/OHE_Navigating_ECLDS_Tutorial_September.webm' type='video/webm' /> <track kind='captions' src='videos/OHE_Navigating_ECLDS_Tutorial_September.vtt' srclang='en' label='English'> </track> </video>"
            );
            $("#video1").html("");
            $("#video3").html("");
            $("#video4").html("");
            $("#video5").html("");
            $("#video6").html("");
            $("#video7").html("");
            $("#video8").html("");
            $("#video9").html("");
            $("#video0").html("");
          } else if (location.hash.indexOf("videos3") > -1) {
            gtag("event", "View", {
              event_category: "Report",
              event_label: "vid3",
            });
            $("#video3").html(
              "<video class='video-js vjs-default-skin' controls preload='auto' width='640' height='360' poster='videos/PROD045771.jpg' data-setup='{}' style='width: 640px; height: 360px;  border: 1px solid black; '> <source src='videos/PROD045771.mp4' type='video/mp4' /> <source src='videos/PROD045771.webm' type='video/webm' /> <track kind='captions' src='videos/PROD045771.vtt' srclang='en' label='English'> </track> </video>"
            );
            $("#video1").html("");
            $("#video2").html("");
            $("#video4").html("");
            $("#video5").html("");
            $("#video6").html("");
            $("#video7").html("");
            $("#video8").html("");
            $("#video9").html("");
            $("#video0").html("");
          } else if (location.hash.indexOf("videos4") > -1) {
            gtag("event", "View", {
              event_category: "Report",
              event_label: "vid4",
            });
            $("#video4").html(
              "<video class='video-js vjs-default-skin' controls preload='auto' width='640' height='360' poster='videos/ECLDS_ProgramPlanning.jpg' data-setup='{}' style='width: 640px; height: 360px;  border: 1px solid black; '> <source src='videos/ECLDS_ProgramPlanning.mp4' type='video/mp4' /> <source src='videos/ECLDS_ProgramPlanning.webm' type='video/webm' /> <track kind='captions' src='videos/ECLDS_ProgramPlanning.vtt' srclang='en' label='English'> </track> </video>"
            );
            $("#video1").html("");
            $("#video2").html("");
            $("#video3").html("");
            $("#video5").html("");
            $("#video6").html("");
            $("#video7").html("");
            $("#video8").html("");
            $("#video9").html("");
            $("#video0").html("");
          } else if (location.hash.indexOf("videos5") > -1) {
            gtag("event", "View", {
              event_category: "Report",
              event_label: "vid5",
            });
            $("#video5").html(
              "<video class='video-js vjs-default-skin' controls preload='auto' width='640' height='360' poster='videos/OHE_ECLDS_DataUseToolkit.jpg' data-setup='{}' style='width: 640px; height: 360px;  border: 1px solid black; '> <source src='videos/OHE_ECLDS_DataUseToolkit.mp4' type='video/mp4' /> <source src='videos/OHE_ECLDS_DataUseToolkit.webm' type='video/webm' /> <track kind='captions' src='videos/OHE_ECLDS_DataUseToolkit.vtt' srclang='en' label='English'> </track> </video>"
            );
            $("#video1").html("");
            $("#video2").html("");
            $("#video3").html("");
            $("#video4").html("");
            $("#video6").html("");
            $("#video7").html("");
            $("#video8").html("");
            $("#video9").html("");
            $("#video0").html("");
          } else if (location.hash.indexOf("videos6") > -1) {
            gtag("event", "View", {
              event_category: "Report",
              event_label: "vid6",
            });
            $("#video6").html(
              "<video class='video-js vjs-default-skin' controls preload='auto' width='640' height='360' poster='videos/mde031978.jpg' data-setup='{}' style='width: 640px; height: 360px;  border: 1px solid black; '> <source src='videos/mde031978.mp4' type='video/mp4' /> <source src='videos/mde031978.webm' type='video/webm' /> <track kind='captions' src='videos/mde031978.vtt' srclang='en' label='English'> </track> </video>"
            );
            $("#video1").html("");
            $("#video2").html("");
            $("#video3").html("");
            $("#video4").html("");
            $("#video5").html("");
            $("#video7").html("");
            $("#video8").html("");
            $("#video9").html("");
            $("#video0").html("");
          } else if (location.hash.indexOf("videos7") > -1) {
            gtag("event", "View", {
              event_category: "Report",
              event_label: "vid7",
            });
            $("#video7").html(
              "<video class='video-js vjs-default-skin' controls preload='auto' width='640' height='360' poster='videos/mde031980.jpg' data-setup='{}' style='width: 640px; height: 360px;  border: 1px solid black; '> <source src='videos/mde031980.mp4' type='video/mp4' /> <source src='videos/mde031980.webm' type='video/webm' /> <track kind='captions' src='videos/mde031980.vtt' srclang='en' label='English'> </track> </video>"
            );
            $("#video1").html("");
            $("#video2").html("");
            $("#video3").html("");
            $("#video4").html("");
            $("#video5").html("");
            $("#video6").html("");
            $("#video8").html("");
            $("#video9").html("");
            $("#video0").html("");
          } else if (location.hash.indexOf("videos8") > -1) {
            gtag("event", "View", {
              event_category: "Report",
              event_label: "vid8",
            });
            $("#video8").html(
              "<video class='video-js vjs-default-skin' controls preload='auto' width='640' height='360' poster='videos/mde031982.jpg' data-setup='{}' style='width: 640px; height: 360px;  border: 1px solid black; '> <source src='videos/mde031982.mp4' type='video/mp4' /> <source src='videos/mde031982.webm' type='video/webm' /> <track kind='captions' src='videos/mde031982.vtt' srclang='en' label='English'> </track> </video>"
            );
            $("#video1").html("");
            $("#video2").html("");
            $("#video3").html("");
            $("#video4").html("");
            $("#video5").html("");
            $("#video7").html("");
            $("#video9").html("");
            $("#video6").html("");
            $("#video0").html("");
          } else if (location.hash.indexOf("videos9") > -1) {
            gtag("event", "View", {
              event_category: "Report",
              event_label: "vid9",
            });
            $("#video9").html(
              "<video class='video-js vjs-default-skin' controls preload='auto' width='640' height='360' poster='videos/mde031981.jpg' data-setup='{}' style='width: 640px; height: 360px;  border: 1px solid black; '> <source src='videos/mde031981.mp4' type='video/mp4' /> <source src='videos/mde031981.webm' type='video/webm' /> <track kind='captions' src='videos/mde031981.vtt' srclang='en' label='English'> </track> </video>"
            );
            $("#video1").html("");
            $("#video2").html("");
            $("#video3").html("");
            $("#video4").html("");
            $("#video5").html("");
            $("#video7").html("");
            $("#video8").html("");
            $("#video6").html("");
            $("#video0").html("");
          } else if (location.hash.indexOf("videos0") > -1) {
            gtag("event", "View", {
              event_category: "Report",
              event_label: "vid10",
            });
            $("#video0").html(
              "<video class='video-js vjs-default-skin' controls preload='auto' width='640' height='360' poster='videos/OHE_ECLDS_CommunityNeedsAssessment.jpg' data-setup='{}' style='width: 640px; height: 360px;  border: 1px solid black; '> <source src='videos/OHE_ECLDS_CommunityNeedsAssessment.mp4' type='video/mp4' /> <source src='videos/OHE_ECLDS_CommunityNeedsAssessment.webm' type='video/webm' /> <track kind='captions' src='videos/OHE_ECLDS_CommunityNeedsAssessment.vtt' srclang='en' label='English'> </track> </video>"
            );
            $("#video1").html("");
            $("#video2").html("");
            $("#video3").html("");
            $("#video4").html("");
            $("#video5").html("");
            $("#video7").html("");
            $("#video8").html("");
            $("#video6").html("");
            $("#video9").html("");
          }

          if (
            hash.indexOf("birthOutcomes") > -1 ||
            hash.indexOf("maternalTraitsProficiency") > -1 ||
            hash.indexOf("ECSEto3rdGrade") > -1
          ) {
            setTimeout(function () {
              $.each(charts, function (index, value) {
                if (this.userOptions.lineData != null && this.done != true) {
                  var dataPt = Number($("#stateData")[0].textContent);
                  this.addSeries(
                    {
                      name: "Statewide",
                      type: "spline",
                      data: [
                        {
                          x: -0.4,
                          y: dataPt,
                        },
                        dataPt,
                        {
                          x: this.userOptions.lineSpan,
                          y: dataPt,
                        },
                      ],
                      tooltip: {
                        valueSuffix: "%",
                      },
                      color: "#8d3f2b",
                      lineWidth: 2,
                      marker: {
                        lineWidth: 2,
                        enabled: false,
                      },
                    },
                    false
                  );
                  this.xAxis[0].setExtremes(
                    0.1,
                    this.userOptions.lineSpan - 0.4
                  );
                  this.done = true;
                }
              });
            }, 3000);
          }

          if (hash.indexOf("summaryReport") > -1) {
            var n = (hash.match(/orgId/g) || []).length;
            // We only want one pane on the summary report, if we are coming from a page we had more than one open, default to statewide with 1 pane

            if (n > 1) {
              location.hash =
                "#summaryReport/orgId--999999000__groupType--state__FISCAL_YEAR--2014__p--1";
              setTimeout(function () {
                Backbone.trigger("reportSet");
              }, 100);
            }
            $(".dataBox").css("width", "96%");
            $(".controls").css("display", "none");
            $(".dataBox").css("max-width", "1000px");
            wideBox = true;

            //      setTimeout(function() {
            $("#AllOrgKindergartners").waitUntilExists(function () {
              $("#AllOrgKindergartners").tableExport({
                headings: true, // (Boolean), display table headings (th elements) in the first row
                formats: ["xlsx"], // (String[]), filetypes for the export
                fileName: "AllOrgKindergartners", // (id, String), filename for the downloaded file
                bootstrap: true, // (Boolean), style buttons using bootstrap
                position: "top", // (top, bottom), position of the caption element relative to table
              });
              $("#ChildCareAssistanceProgram").tableExport({
                headings: true, // (Boolean), display table headings (th elements) in the first row
                formats: ["xlsx"], // (String[]), filetypes for the export
                fileName: "ChildCareAssistanceProgram", // (id, String), filename for the downloaded file
                bootstrap: true, // (Boolean), style buttons using bootstrap
                position: "top", // (top, bottom), position of the caption element relative to table
              });
              $("#EarlyChildhoodFamilyEducation").tableExport({
                headings: true, // (Boolean), display table headings (th elements) in the first row
                formats: ["xlsx"], // (String[]), filetypes for the export
                fileName: "EarlyChildhoodFamilyEducation", // (id, String), filename for the downloaded file
                bootstrap: true, // (Boolean), style buttons using bootstrap
                position: "top", // (top, bottom), position of the caption element relative to table
              });
              $("#EarlyChildhoodSpecialEducation").tableExport({
                headings: true, // (Boolean), display table headings (th elements) in the first row
                formats: ["xlsx"], // (String[]), filetypes for the export
                fileName: "EarlyChildhoodSpecialEducation", // (id, String), filename for the downloaded file
                bootstrap: true, // (Boolean), style buttons using bootstrap
                position: "top", // (top, bottom), position of the caption element relative to table
              });
              $("#MnDistrictPreSchool").tableExport({
                headings: true, // (Boolean), display table headings (th elements) in the first row
                formats: ["xlsx"], // (String[]), filetypes for the export
                fileName: "MnDistrictPreSchool", // (id, String), filename for the downloaded file
                bootstrap: true, // (Boolean), style buttons using bootstrap
                position: "top", // (top, bottom), position of the caption element relative to table
              });
            });
            //   }, 6000);
          } else {
            if (wideBox) {
              $(".dataBox").css("width", "");
              $(".controls").css("display", "");
              $(".dataBox").css("max-width", "");

              setTimeout(function () {
                Backbone.trigger("reportSet");
              }, 0);
              wideBox = false;
            }
          }
          repName = location.hash.substring(0, location.hash.indexOf("/"));
          if (repName.length < 1)
            repName = hash.substring(0, 10);
        });

      }

      function handleCommonSourceLoadingError(error) {
        attempts++;

        if (error instanceof Error) {
          $("#loading .techError").html(
            "There was an error during app setup: " +
            "<br />" +
            error.message +
            "<br />" +
            error.stack
          );
        } else {
          if (attempts < maxAttempts) {
            var $spinnerBox = $("#pageLoadingSpinnerBox").show();
            window.loadingSpinner.spin($spinnerBox[0]);
            $("#loading > .message").html("One moment, please...");
            $("#loading > .error").html(
              "We're having trouble loading some of our data sources, retrying..."
            );
            $("#loading .techError").html(
              "<a style='color:#CCE' onclick=\"document.getElementById('errorDetails').style.display = 'block';return false;\" href='#'>Show details</a><br />" +
              "<div style='display:none;' id='errorDetails'>" +
              "<br />HTTP Status " +
              error.status +
              "<br /><br />Message:<br />" +
              $("<div>" + error.responseText + "</div>").text() +
              "</div>"
            );
          }
        }
        Util.reportPromiseException(error);

        if (attempts < maxAttempts) {
          _.delay(function () {
            commonSourcesLoaded = commonDataSourceManager
              .fetchCommonDataSources()
              .then(afterCommonSourcesLoaded)
              .catch(handleCommonSourceLoadingError);
          }, 2000);
        }
        return error;
      }

      // once all data sources are loaded, fire up the main workspace
      // controller object. NOTE: waiting for all of them (and their
      // processing) to complete before we reveal the UI gets rid of jank!

      commonSourcesLoaded
        .then(afterCommonSourcesLoaded)
        .catch(handleCommonSourceLoadingError);
    });
  });

  return exports;
});

